import { AssetCatDropDownDto, AssetDto, AssetGridDto, AssetsClasificationDropDownDto, AssetServiceChecklistDTO, AssetsReportDto, AssetSubCatDropDownDto, UpdateServiceRemarksDto } from '@gtpl/shared-models/asset-management';
import { AssetServiceReq, ErrorResponse, GlobalVariableValues, MessageParameters, ServiceFrequency, ServiceStatusEnum } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { Injectable, Query } from '@nestjs/common';
import { AssetsAdapter } from './dto/open-assets-adpater';
import { AssetsDto } from './dto/open-assets-dto';
import { Assets } from './open-assets-entity';
import { AssetsResponseModel } from 'libs/shared-models/asset-management/src/lib/open-assets/create-open-assets-response';
import { AssetsRequest } from './dto/assets.request';
import { InjectRepository } from '@nestjs/typeorm';
import { Between, getManager, Index, LessThan, MoreThan, Repository } from 'typeorm';
import { AssetsRepository } from './dto/opens-assets-repository';
import { AssetByCode } from './dto/asset-by-code';
import { AssetLocationMapping } from '../asset-location-mapping/entity/asset-location-mapping.entity';
import { AssetLocationTransaction } from '../asset-location-mapping/entity/asset-location-transaction.entity';
import { AssetLocationMappingRepository } from '../asset-location-mapping/repository/asset-location-mapping.repository';
import { AssetAssignment } from '../asset-assignment/entity/asset-assignment.entity';
import moment from 'moment';
import { AssetAssignmentTransaction } from '../asset-assignment/entity/asset-assignment-transaction.entity';
import { AssetAssignmentRepository } from '../asset-assignment/repository/asset-assignment.repository';
import { LocationRepository } from '../locations/dto/location-repository';
import { AssetStatusEnum } from 'libs/shared-models/common-models/src/lib/enum/asset-status.enum';
import { AssetByStatus } from './dto/asset-by-status.dto';
import appSettings from 'apps/services/config';
import { AssetAssignmentDto } from '../asset-assignment/dto/asset-assignment.dto';
import { AssetAssignmentTransactionDto } from '../asset-assignment/dto/asset-assignment-transaction.dto';
import { whatsApp } from '../../../../whatsapp';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { AssetById } from './dto/asset-by-id.dto';
import { AssetRACIReport } from './dto/raci-report-dto';
import { length } from 'class-validator';
import { AbstractDetails } from './dto/abstract-details-dto';
import { AssetServiceRepository } from './dto/asset-service.repository';
import { AssetServiceAdapater } from './dto/asset-service.adapter';
import { AssetServiceDto } from './dto/asset-service.dto';
import { AssetsId } from './dto/asset-id-req';
import { AssetsCatagoryByIdDto } from '../assets-sub-catagory/asset-catagory-id-request';
import { AssetServiceRportReq } from "libs/shared-models/asset-management/src/lib/open-assets/asset-by-status.dto";
import { AssetServiceHelper } from "./assets-service-helper"
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { UpdateRemarksDto } from './dto/remarks-update.dto';
import { Cron } from '@nestjs/schedule';
import { AssetTransaction } from './asset-transaction-entity';
import { AssetTransactionDto } from './dto/asset-transaction-dto';
import { AssetTransactionAdapter } from './dto/asset-transaction-adapter';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { AssetMaintainanceService } from '../asset-maintainance/asset-maintainance.service';
import { AssetServiceChecklist } from './asset-service-checklist.entity';
import { AssetService } from './asset-service.entity';
import { ChecklistRepository } from './dto/checklist-repository';
import { UpdateChecklist } from './dto/checklist-update.dto';
import { AssetServiceChecklistDto } from './dto/asset-service-checklist.dto';
import { AssetChecklistRequestDto } from './dto/checklist-request.dto';
@Injectable()
export class AssetsService {


    constructor(
        private adapter: AssetsAdapter,
        @InjectRepository(Assets)
        private repo: Repository<Assets>,
        private locationRepo: AssetLocationMappingRepository,
        @InjectRepository(AssetLocationTransaction)
        private locationTransRepo: Repository<AssetLocationTransaction>,

        private assignmentRepo: AssetAssignmentRepository,
        @InjectRepository(AssetAssignmentTransaction)
        private assignmentTransRepo: Repository<AssetAssignmentTransaction>,

        private locationMasterRepo: LocationRepository,
        private wpService: WhatsAppNotificationService,
        private assetServiceRepo: AssetServiceRepository,
        private assetServiceAdapter: AssetServiceAdapater,
        private locationMapRepo: AssetLocationMappingRepository,
        private assetServiceHelper: AssetServiceHelper,
        @InjectRepository(AssetTransaction)
        private assetTransactionRepo: Repository<AssetTransaction>,
        private assetTransactionAdapter: AssetTransactionAdapter,
        private wtsAppBroadCatService: WhatsappBroadCastService,
        private maintainanceService: AssetMaintainanceService,
        private checklistRepo: ChecklistRepository

    ) { }

    async create(createDto: AssetsDto): Promise<CommonResponse> {
        const qrymanager = getManager();
        const manager = new GenericTransactionManager
        try {
            await manager.startTransaction()
            const entity = this.adapter.convertDtoToEntity(createDto);
            if (createDto.status == AssetStatusEnum.GRN) {
                entity.status = AssetStatusEnum.GRN
            }
            if (createDto.assetId) {
                entity.assetType = createDto.assetType
            } else {
                const qry = `SELECT it.asset_type FROM ` + appSettings.masters_db + `.items it WHERE it.item_id = ${createDto.assetsName}`
                const data: { asset_type: string }[] = await qrymanager.query(qry)
                entity.assetType = data[0].asset_type
                const assetCode = `${createDto.assetsName + '-' + moment(Date.now()).format('mmss')}`
                entity.assetsCode = assetCode;
            }
            entity.status = createDto.assetcondition !== 'Damaged' ? AssetStatusEnum.INSTOCK : AssetStatusEnum.DAMAGED
            if (entity.dateOfPurchased == null) {
                entity.dateOfPurchased = new Date();
            }
            const saved = await manager.getRepository(Assets).save(entity);
            const saveTransaction = await manager.getRepository(AssetTransaction).save(entity)
            if (!saved) {
                throw new ErrorResponse(1111, 'Failed to save')
            }
            let locationMappingRepo: AssetLocationMapping;
            if (createDto.currentLocation) {
                const locationDetail = await this.locationRepo.findOne({ where: { assetsId: saved.assetId } })
                if (!locationDetail) {
                    const locationEntity = new AssetLocationMapping();
                    locationEntity.assetsId = saved;
                    locationEntity.createdUser = saved.createdUser;
                    locationEntity.locationId = createDto.currentLocation;
                    locationMappingRepo = await manager.getCustomRepository(AssetLocationMappingRepository).save(locationEntity);
                    // location transaction mapping 
                    const locationEntityTrans = new AssetLocationTransaction();
                    locationEntityTrans.assetId = saved.assetId;
                    locationEntityTrans.createdUser = saved.createdUser;
                    locationEntityTrans.locationId = createDto.currentLocation;
                    locationEntityTrans.assetLocationMapping = locationMappingRepo;
                    const locationMappingTransRepo = await manager.getRepository(AssetLocationTransaction).save(locationEntityTrans);
                }
            }
            if (createDto.serviceStatus == 'yes' && createDto.serviceType == 'planned') {
                if (createDto.assetId) {
                    const updateServices = await manager.getCustomRepository(AssetServiceRepository).delete({ assetId: createDto.assetId, status: ServiceStatusEnum.OPEN })
                }
                const saveService = await this.createPlannedServiceEntries(saved, manager)
                if (saveService.status) {
                    await manager.completeTransaction()
                    return new CommonResponse(true, 98898, "Asset Successfully Created", saved);
                }
            } else {
                await manager.completeTransaction()
                if (saved) {
                    const manager = getManager()
                    let qry = `SELECT it.item_name AS assets_name , aas.assets_code,aas.asset_cost,aas.date_of_purchased,aas.warrenty_expired_date,aas.insurance_date FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE aas.asset_id = ${saved.assetId}`
                    const data = await manager.query(qry);
                    const parameters = [
                        { "type": "text", "text": moment().format('DD-MM-YYYY') },
                        { "type": "text", "text": data[0].assets_name ? data[0].assets_name : "No Data" },
                        { "type": "text", "text": data[0].assets_code ? data[0].assets_code : "No Data" },
                        { "type": "text", "text": data[0].asset_cost ? data[0].asset_cost : "No Data" },
                        { "type": "text", "text": moment(data[0].date_of_purchased).format('DD-MM-YYYY') ? moment(data[0].date_of_purchased).format('DD-MM-YYYY') : "No Data" },
                        { "type": "text", "text": moment(data[0].warrenty_expired_date).format('DD-MM-YYYY') ? moment(data[0].warrenty_expired_date).format('DD-MM-YYYY') : "No Data" },
                        { "type": "text", "text": moment(data[0].insurance_date).format('DD-MM-YYYY') ? moment(data[0].insurance_date).format('DD-MM-YYYY') : "No Data" },
                    ];
                    for (const contact of whatsApp.contacts) {
                        let statusFlag = true
                        const req = await new MessageParameters(contact, 'asset_create_message', parameters, "en_us")
                        const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                        if (!messageStatus.status) {
                            statusFlag = false
                        }
                        else {
                            const testdata = 'INSERT INTO ' + appSettings.whatsapp_db + '.whatsapp_logs (contact_no,template_name,project_name,company_id,module_id) VALUES("' + contact + '","asset_assign","Brandix_assets",' + GlobalVariableValues.companyId + ',' + GlobalVariableValues.assetManagementmoduleId + ')'
                            const result = await qrymanager.query(testdata)
                            const res = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
                        }

                    }
                }
                return new CommonResponse(true, 98898, "Asset Successfully Created", saved);
            }

        } catch (error) {
            await manager.releaseTransaction()
            return new CommonResponse(false, 98898, "Error while creating",);
        }
    }

    async getAllAssets(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_category,isc.item_sub_category , it.item_name AS assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,it.item_name FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id > 0 `
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` GROUP BY aas.assets_code ORDER BY it.item_name ASC`
        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, employee_name: string, dept_name: string, service_type: string, service_status: ServiceStatusEnum, amc_provider: string, item_sub_category: string, item_name: string
        }[] = await manager.query(getEntities)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.item_sub_category, data.asset_type, data.employee_name, data.dept_name, data.service_status, data.service_type, data.amc_provider))
        })
        return new CommonResponse(true, 1, 'Data retrieved', response)
    }

    async getAllAssetsForMaintainance(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_category,isc.item_sub_category , it.item_name AS assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,it.item_name FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.status != "UNDERMAINTENANCE" GROUP BY aas.assets_code ORDER BY it.item_name ASC`
        const data=await manager.query(getEntities)      

        if(data.length > 0){
          return new CommonResponse(true,1001,"Data retrieved successfully. ",data);
        }
        else{
          return new CommonResponse(false,1010,"No data found. ");
        }
    }


    async getByStatus(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
        SELECT isc.item_sub_category_id AS asset_category,isc.item_sub_category,it.item_id AS assets_name, it.item_name AS item_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,empn.employee_id AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,aas.plant,unc.unit_name AS plantName,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_status,aas.service_type,aas.frequency_of_service,
        locc.location_id,lo.location_id ,loc.location_name ,aas.asset_type ,aas.month,aas.day,datediff(date(now()),aas.date_of_purchased) as assetAge,aas.asset_mode,aas.amc_provider,aas.insurance_reference_number
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empn ON empn.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id >0 `;
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.status) {
            getEntities = getEntities + 'and aas.status = "' + req.status + '"'
        }
        if (req.amcAvailable) {
            getEntities = getEntities + 'and aas.amc_available = "' + req.amcAvailable + '"'
        }
        if (req.warrentyAvailable) {
            getEntities = getEntities + 'and aas.warrenty_available = "' + req.warrentyAvailable + '"'
        }
        if (req.insuranceAvailable) {
            getEntities = getEntities + 'and aas.insurance = "' + req.insuranceAvailable + '"'
        }
        if (req.fromDate) {
            getEntities = getEntities + 'and aas.date_of_purchased BETWEEN "' + req.fromDate + '" AND "' + req.toDate + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_name = "' + req.department + '" and aas.status = "' + AssetStatusEnum.INUSE + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and assi.employee_id = "' + req.employeeId + '" and aas.status = "' + AssetStatusEnum.INUSE + '"'
        }
        if (req.warrantyStartDate) {
            getEntities = getEntities + 'and aas.warrenty_expired_date BETWEEN "' + req.warrantyStartDate + '" AND "' + req.warrantyEndDate + '"'
        }
        if (req.insuranceStartDate) {
            getEntities = getEntities + 'and aas.insurance_date BETWEEN "' + req.insuranceStartDate + '" AND "' + req.insuranceEndDate + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.assetCost != undefined) {
            if (req.assetCost == '0-25,000') {
                getEntities = getEntities + ' and aas.asset_cost between 0 and 25000'
            }
            if (req.assetCost == '25,000-50,000') {
                getEntities = getEntities + ' and aas.asset_cost between 25000 and 50000'
            }
            if (req.assetCost == '50,000-1 lak') {
                getEntities = getEntities + ' and aas.asset_cost between 50000 and 100000'
            }
            if (req.assetCost == 'above 1 lak') {
                getEntities = getEntities + ' and aas.asset_cost > 100000'
            }
        }
        if (req.aging != undefined) {
            if (req.aging != undefined) {
                if (req.aging == '0-50') {
                    getEntities = getEntities + ' having assetAge < 50 '
                }
                if (req.aging == '0-90') {
                    getEntities = getEntities + ' having assetAge between 0 and 90'
                }
                if (req.aging == '0-180') {
                    getEntities = getEntities + ' having assetAge between 0 and 180'
                }
                if (req.aging == '0-365') {
                    getEntities = getEntities + ' having assetAge between 0 and 365'
                }
                if (req.aging == '0-1095') {
                    getEntities = getEntities + ' having assetAge between 0 and 1095'
                }
                if (req.aging == '0-1825') {
                    getEntities = getEntities + '  having assetAge between 0 and 1825'
                }
                if (req.aging == 'above 1825') {
                    getEntities = getEntities + '  having assetAge > 1825'
                }
            }
        }
        if (req.assetMode) {
            getEntities = getEntities + ' and aas.asset_mode = "' + req.assetMode + '"'
        }
        if (req.assetCost != undefined) {
            getEntities = getEntities + ` ORDER BY CAST(aas.asset_cost AS UNSIGNED) ASC `
        } else if (req.insuranceStartDate) {
            getEntities = getEntities + ` ORDER BY aas.insurance_date ASC `
        } else if (req.warrantyStartDate) {
            getEntities = getEntities + ` ORDER BY aas.warrenty_expired_date ASC `
        } else if (req.fromDate) {
            getEntities = getEntities + ` ORDER BY aas.date_of_purchased ASC `
        } else if (req.aging != undefined) {
            getEntities = getEntities + ` ORDER BY assetAge ASC`
        } else {
            getEntities = getEntities + ` ORDER BY it.item_name ASC `
        }

        const assetdata: {
            asset_category: number, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: number, asset_id: number, location_name: string, asset_type: string, employee_name: string, dept_name: string, item_sub_category: string, item_name: string, plantName: string, service_status: string, service_type: string, frequency_of_service: string, month: any, day: any, assetAge: any, asset_mode: string, amc_provider: string, insurance_reference_number: string
        }[] = await manager.query(getEntities)
        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetGridDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.item_sub_category, data.asset_type, data.employee_name, data.dept_name, data.service_status, data.service_type, data.amc_provider, data.frequency_of_service, data.month, data.day, null, data.plantName, null, null, null, null, data.asset_mode, data.assetAge, data.insurance_reference_number))
        })
        return new CommonResponse(true, 1, 'Data retrieved successfully', response)
    }

    async activateOrDeactivate(req: AssetsRequest): Promise<CommonResponse> {
        try {
            const Exists = await this.getAssetsById(req.assetId);
            if (Exists) {
                if (req.versionFlag !== Exists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Asset information.Refresh and try again');
                } else {

                    const Status = await this.repo.update(
                        { assetId: req.assetId },
                        { isActive: req.isActive, updatedUser: req.updatedUser });

                    if (Exists.isActive) {
                        if (Status.affected) {
                            return new CommonResponse(true, 1, 'Asset Deactivated Sucessfully');
                        } else {
                            throw new ErrorResponse(10111, 'Asset is already deactivated');
                        }
                    } else {
                        if (Status.affected) {

                            return new CommonResponse(true, 2, 'Asset Activated Sucessfully');
                        } else {
                            throw new ErrorResponse(10112, 'asset is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAssetsById(assetId: number): Promise<Assets> {
        const Response = await this.repo.findOne({
            where: { assetId: assetId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getByAssetCode(assetCode: AssetByCode): Promise<CommonResponse> {
        const getData = [];
        const assetObject: { asset_id: number } = await this.repo.createQueryBuilder('assets')
            .select('asset_id')
            .where(`assets_code = '${assetCode.assetsCode}'`)
            .getRawOne();
        const assetCodeStatus = Number(assetObject.asset_id)
        const Response = await this.repo.findOne({ where: { assetId: assetCodeStatus } });
        const manager = getManager();
        const qry = `SELECT u.unit_name as plantName,aas.asset_id, it.item_name AS assetname,its.item_sub_category AS assetCategory,lo.location_id ,loc.location_name,unc.unit_name as plant,emp.employee_name 
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN ` + appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN ` + appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
        LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories its ON its.item_sub_category_id = aas.asset_category 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset Left join ` + appSettings.masters_db + `.unitcodes u on u.unit_code_id=aas.plant 
        WHERE aas.asset_id = ${assetCodeStatus}
        ORDER BY it.item_name ASC `
        const data = await manager.query(qry)
        getData.push(Response)
        getData.push(data)

        if (Response) {
            return new CommonResponse(true, 1, 'Data Retrieved', getData)
        }
        else {
            return new CommonResponse(false, 99898, 'Asset Code not found')
        }
    }

    async getAllAssetsEligileForCheckIn(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT isc.item_sub_category AS asset_category, it.item_name AS assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,aas.owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,it.item_name,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,DATEDIFF(DATE(NOW()),aas.date_of_purchased) AS assetAge,aas.asset_mode,
        locc.location_id,lo.location_id ,loc.location_name FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        WHERE aas.status = '${AssetStatusEnum.INSTOCK}' `
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        // if (req.plantId) {
        //     getEntities = getEntities + 'and aas.plant = ' + req.plantId + ''
        // }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType + '"'
        }
        // if(req.department){
        //     getEntities = getEntities + 'and dep.dept_name = "' + req.department +'"'
        // }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and assi.employee_id = ' + req.employeeId + ' and aas.status = "' + AssetStatusEnum.INUSE + '"'
        }
        if (req.plantId && req.location) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId + ' and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }

        getEntities = getEntities + ` ORDER BY it.item_name ASC `

        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, assetAge: any, item_name: string, asset_mode: string
        }[] = await manager.query(getEntities)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.asset_category, data.asset_type, null, null, null, null, null, null, null, null, null, null, null, null, null, null, data.asset_mode, data.assetAge))
        })
        return new CommonResponse(true, 1, 'Data retrieved successfully', response)
    }

    async assetsCheckInMonthWiseCount(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const query = `SELECT SUM(IF(MONTH(check_in) = 1,1,0)) AS jan ,SUM(IF(MONTH(check_in) = 2,1,0)) AS feb,SUM(IF(MONTH(check_in) = 3,1,0)) AS mar,
          SUM(IF(MONTH(check_in) = 4,1,0)) AS apr , SUM(IF(MONTH(check_in) = 5,1,0)) AS may ,
          SUM(IF(MONTH(check_in) = 6,1,0)) AS jun , SUM(IF(MONTH(check_in) = 7,1,0)) AS july ,
          SUM(IF(MONTH(check_in) = 8,1,0)) AS aug , SUM(IF(MONTH(check_in) = 9,1,0)) AS sep,
          SUM(IF(MONTH(check_in) = 10,1,0)) AS octo , SUM(IF(MONTH(check_in) = 11,1,0)) AS nov ,
          SUM(IF(MONTH(check_in) = 12,1,0)) AS decm  FROM ` + appSettings.assets_db + `.asset_assignment_transactions `
            const dropData = await manager.query(query);
            data.push(dropData)
            const query1 = `SELECT SUM(IF(MONTH(check_out) = 1,1,0)) AS jan ,SUM(IF(MONTH(check_out) = 2,1,0)) AS feb,SUM(IF(MONTH(check_out) = 3,1,0)) AS mar,
          SUM(IF(MONTH(check_out) = 4,1,0)) AS apr , SUM(IF(MONTH(check_out) = 5,1,0)) AS may ,
          SUM(IF(MONTH(check_out) = 6,1,0)) AS jun , SUM(IF(MONTH(check_out) = 7,1,0)) AS july ,
          SUM(IF(MONTH(check_out) = 8,1,0)) AS aug , SUM(IF(MONTH(check_out) = 9,1,0)) AS sep,
          SUM(IF(MONTH(check_out) = 10,1,0)) AS octo , SUM(IF(MONTH(check_out) = 11,1,0)) AS nov ,
          SUM(IF(MONTH(check_out) = 12,1,0)) AS decm  FROM ` + appSettings.assets_db + `.asset_assignment_transactions `
            const dropData1 = await manager.query(query1);
            data.push(dropData1)
            if (dropData) {
                return new CommonResponse(true, 11608, 'Month Count Retrived Successsfully', data)
            } else {
                return new CommonResponse(true, 11608, 'Something went wrong')
            }
        }
        catch (error) {
            return error
        }

    }

    async assetsCount(): Promise<CommonResponse> {
        const data = [];
        try {

            const manager = getManager()
            const query = `SELECT COUNT(assets_code) AS no_of_assets FROM ` + appSettings.assets_db + `.assets`
            const dropData = await manager.query(query);
            data.push(dropData);
            const query1 = `SELECT COUNT(check_in) AS today_checkins FROM ` + appSettings.assets_db + `.asset_assignment  WHERE check_in = Date(now())`
            const dropData1 = await manager.query(query1);
            data.push(dropData1);
            const query2 = `SELECT COUNT(check_out) AS today_checkouts FROM ` + appSettings.assets_db + `.asset_assignment  WHERE check_out = Date(now())`
            const dropData2 = await manager.query(query2);
            data.push(dropData2);
            const query3 = `SELECT COUNT(assets_code) AS undermaintenance_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS undermaintainance_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS='UNDERMAINTENANCE' GROUP BY aas.asset_type`
            const dropData3 = await manager.query(query3);
            data.push(dropData3);
            const query4 = `SELECT COUNT(asset_id) AS damaged_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS asset_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS = 'DAMAGED' GROUP BY aas.asset_type`
            const dropData4 = await manager.query(query4);
            data.push(dropData4);
            const query5 = `SELECT COUNT(location_id) AS locations_count FROM ` + appSettings.assets_db + `.location`
            const dropData5 = await manager.query(query5);
            data.push(dropData5);
            const query6 = `SELECT COUNT(asset_id) AS checkin_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS checkin_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS='INUSE' GROUP BY aas.asset_type`
            const dropData6 = await manager.query(query6);
            data.push(dropData6);
            const query7 = `SELECT COUNT(asset_id) AS instock_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS instock_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS='INSTOCK' GROUP BY aas.asset_type`;
            const dropData7 = await manager.query(query7);
            data.push(dropData7);
            const query8 = `SELECT COUNT(asset_id) AS total_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS asset_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name GROUP BY aas.asset_type`
            const dropData8 = await manager.query(query8);
            data.push(dropData8);
            const query9 = `SELECT COUNT(asset_id) AS decommisioned_assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS decommisioned_cost,aas.asset_type FROM ` + appSettings.assets_db + `.assets aas  LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE STATUS = '${AssetStatusEnum.RETIRED}' GROUP BY aas.asset_type`
            const dropData9 = await manager.query(query9);
            data.push(dropData9);


            if (data) {
                return new CommonResponse(true, 11608, "Assets retrieved successfully", data)
            } else {
                return new CommonResponse(true, 11608, "Something went wrong")
            }
        }
        catch (error) {
            return error
        }
    }

    async assetsStatusCount(): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = ` SELECT COUNT(asset_id) AS assets ,status FROM ` + appSettings.assets_db + `.assets 
          GROUP BY status `
            const dropData = await manager.query(query);
            if (dropData) {
                return new CommonResponse(true, 11608, "Assets retrieved successfully", dropData)
            } else {
                return new CommonResponse(true, 11608, "Something went wrong")
            }
        }
        catch (error) {
            return error
        }
    }


    async getAssetSummaryReport() {
        try {
            const manager = getManager()
            let assetsQuery = `SELECT COUNT(asset_id) FROM assets WHERE DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)`
            let checkInQuery = `SELECT COUNT(check_in) FROM asset_assignment WHERE DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY`
            let checkOutQuery = `SELECT COUNT(check_out) FROM asset_assignment WHERE DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY`
            let maintainanceQuery = `SELECT COUNT(asset_maintainance_id) FROM asset_maintainance WHERE DATE(created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)`
            const assetsData = await manager.query(assetsQuery);
            const checkInData = await manager.query(checkInQuery);
            const checkOutData = await manager.query(checkOutQuery);
            const maintainanceData = await manager.query(maintainanceQuery);
            const time = moment().subtract(1, "days").format('MMMM Do, YYYY');
            const nowTime = moment().subtract(0, "days").format('MMMM Do, YYYY')
            const parameters = [
                { "type": "text", "text": assetsData.length > 0 ? assetsData : "No Data" },
                { "type": "text", "text": checkInData.length > 0 ? checkInData : "No Data" },
                { "type": "text", "text": checkOutData.length > 0 ? checkOutData : "No Data" },
                { "type": "text", "text": maintainanceData.length > 0 ? maintainanceData : "No Data" }
            ];

        } catch (err) {
            return new ErrorResponse(11108, "Error while sending message")
        }
    }

    @Cron('0 18 * * *')
    async getAssetReport() {
        try {
            const manager = getManager()
            let totalAssets = `SELECT COUNT(assets_name) as totalassets FROM assets`;
            let workingAssets = `SELECT COUNT(assets_name) as workingassets FROM assets WHERE STATUS IN ('INSTOCK','INUSE')`;
            let underMaintainanceAssets = `SELECT COUNT(assets_name) as maintainanceassets FROM assets WHERE STATUS IN ('UNDERMAINTENANCE')`;
            let damagedAssets = `SELECT COUNT(assets_name) as damagedassets FROM assets WHERE STATUS IN ('DAMAGED')`;
            const assets = await manager.query(totalAssets);
            const workingAssetsData = await manager.query(workingAssets);
            const underMaintainanceAssetsData = await manager.query(underMaintainanceAssets);
            const damagedAssetsData = await manager.query(damagedAssets);
            const parameters = [
                { "type": "text", "text": moment().format('DD-MM-YYYY') },
                { "type": "text", "text": assets ? assets[0].totalassets : "No Data" },
                { "type": "text", "text": workingAssetsData ? workingAssetsData[0].workingassets : "No Data" },
                { "type": "text", "text": damagedAssetsData ? damagedAssetsData[0].damagedassets : "No Data" },
                { "type": "text", "text": underMaintainanceAssetsData ? underMaintainanceAssetsData[0].maintainanceassets : "No Data" },

            ];
            for (const contact of whatsApp.contacts) {
                let statusFlag = true
                const req = await new MessageParameters(contact, 'asset_report', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                if (!messageStatus.status) {
                    statusFlag = false
                } else {
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'asset_report', 'Brandix_assets', GlobalVariableValues.assetmanagementcompanyId, GlobalVariableValues.assetManagementmoduleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }


        } catch (err) {
            return new CommonResponse(false, 11108, "Error while sending message")
        }
    }


    async assetMonthwiseReport(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const query = `SELECT SUM(IF(MONTH(created_at) = 1,1,0)) AS jan ,SUM(IF(MONTH(created_at) = 2,1,0)) AS feb,SUM(IF(MONTH(created_at) = 3,1,0)) AS mar,
          SUM(IF(MONTH(created_at) = 4,1,0)) AS apr , SUM(IF(MONTH(created_at) = 5,1,0)) AS may ,
          SUM(IF(MONTH(created_at) = 6,1,0)) AS jun , SUM(IF(MONTH(created_at) = 7,1,0)) AS july ,
          SUM(IF(MONTH(created_at) = 8,1,0)) AS aug , SUM(IF(MONTH(created_at) = 9,1,0)) AS sep,
          SUM(IF(MONTH(created_at) = 10,1,0)) AS octo , SUM(IF(MONTH(created_at) = 11,1,0)) AS nov ,
          SUM(IF(MONTH(created_at) = 12,1,0)) AS decm  FROM ` + appSettings.assets_db + `.assets `
            const dropData = await manager.query(query);
            data.push(dropData)
            if (dropData) {
                return new CommonResponse(true, 11608, 'Month Count Retrived Successsfully', data)
            } else {
                return new CommonResponse(true, 11608, 'Something went wrong')
            }
        }
        catch (error) {
            return error
        }
    }

    async assetsTopWarrenty(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = `SELECT aas.assets_code,aas.warrenty_expired_date , it.item_name AS asset_name ,u.unit_name AS unit,DATEDIFF(aas.warrenty_expired_date,DATE(NOW())) AS aging FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = aas.plant WHERE aas.warrenty_expired_date IS NOT NULL AND aas.warrenty_expired_date>DATE(NOW()) ORDER BY warrenty_expired_date ASC LIMIT 5`

            const dropData = await manager.query(qry)
            data.push(dropData)

            if (dropData) {

                return new CommonResponse(true, 1, ' Data retrievd successfully', data)
            } else {
                return new CommonResponse(false, 99898, 'Something went wrong')
            }
        } catch (error) {
            return error
        }
    }

    async assetsTopInsurance(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = `SELECT aas.assets_code,aas.insurance_date , it.item_name AS asset_name,u.unit_name AS unit,DATEDIFF(aas.insurance_date,DATE(NOW())) AS aging FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = aas.plant WHERE aas.insurance_date IS NOT NULL AND aas.insurance_date>DATE(NOW()) ORDER BY insurance_date ASC LIMIT 5`
            const dropData = await manager.query(qry)
            data.push(dropData)

            if (dropData) {

                return new CommonResponse(true, 1, ' Data retrievd successfully', data)
            } else {
                return new CommonResponse(false, 99898, 'Something went wrong')
            }
        } catch (error) {
            return error
        }
    }

    async getRaciReport(req: AssetRACIReport): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            let getEntities = `SELECT aas.asset_id,it.item_name AS assets_name ,aas.assets_code,aas.status ,em.employee_name AS responsible,emp.employee_name AS accountable ,aas.asset_supplier AS consulted,em.reporting_manager AS informed,lo.location_id ,loc.location_name ,aas.date_of_purchased,unc.unit_name AS plant,aas.asset_type,isc.item_sub_category AS asset_category,aas.asset_invoice_no,aas.asset_serialno
            FROM ` + appSettings.assets_db + `.assets aas 
            LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
            LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant
            LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
            WHERE aas.asset_id> 0 `
            if (req.assetId) {
                getEntities = getEntities + 'and aas.asset_id = "' + req.assetId + '"'
            }
            if (req.ownerOfAsset) {
                getEntities = getEntities + 'and aas.owner_of_asset = "' + req.ownerOfAsset + '"'
            }
            if (req.employeeId) {
                getEntities = getEntities + 'and em.employee_id = "' + req.employeeId + '"'
            }
            if (req.assetSupplier) {
                getEntities = getEntities + 'and aas.asset_supplier = "' + req.assetSupplier + '"'
            }
            if (req.plant) {
                getEntities = getEntities + 'and aas.plant = "' + req.plant + '"'
            }
            if (req.assetCategory) {
                getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
            }
            if (req.assetType) {
                getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
            }

            if (req.location) {
                getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
            }
            if (req.plant && req.location) {
                getEntities = getEntities + 'and aas.plant = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
            }
            if (req.plant > 0 && req.plant != 5) {
                getEntities = getEntities + 'and aas.plant = ' + req.plant
            }
            if (req.status) {
                getEntities = getEntities + 'and aas.status = "' + req.status + '"'
            }
            getEntities = getEntities + ` ORDER BY it.item_name ASC `

            const dropData = await manager.query(getEntities)
            data.push(dropData)

            return new CommonResponse(true, 1, 'Data retrieved', data)
        } catch (error) {
            return error
        }
    }

    async getAllRaciReport(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const qry = `SELECT aas.asset_id,it.item_name AS assets_name ,aas.assets_code,aas.status ,em.employee_name AS responsible,emp.employee_name AS accountable ,aas.asset_supplier AS consulted,em.reporting_manager AS informed,lo.location_id ,loc.location_name ,aas.date_of_purchased,unc.unit_name AS plant,aas.asset_type,isc.item_sub_category AS asset_category
            FROM ` + appSettings.assets_db + `.assets aas 
            LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
            LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
            LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant `
            const dropData = await manager.query(qry)
            data.push(dropData)

            return new CommonResponse(true, 1, 'Data retrieved', data)
        } catch (error) {
            return error
        }
    }

    async assetsDamagedCost(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = ` SELECT it.item_sub_category AS asset_category,SUM(aas.asset_cost) AS cost_of_assets,COUNT(aas.asset_category) AS quantity,u.unit_name AS unit FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = aas.plant WHERE STATUS = 'DAMAGED' GROUP BY asset_category `
            const dropData = await manager.query(qry)
            data.push(dropData)
            return new CommonResponse(true, 1, 'Data retrieved', data)
        } catch (error) {
            return error
        }
    }

    async departmentWiseCount(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const qry = `SELECT COUNT(aas.asset_id) AS asset_count,d.dept_id,d.dept_name,GROUP_CONCAT(em.employee_name) AS employee_name FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = em.department_id WHERE aas.employee_id IS NOT NULL GROUP BY d.dept_id `
            const dropData = await manager.query(qry)
            data.push(dropData)
            return new CommonResponse(true, 1, 'Data retrieved', data)
        } catch (error) {
            return error
        }
    }

    async getExpiredAssets(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT isc.item_sub_category AS asset_category, it.item_name AS assets_name,aas.assets_code AS assetsCode,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,empdet.employee_name AS decommission_approved_by,aas.updated_at,datediff(date(now()),expired_date) as aging,aas.asset_mode FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empdet ON empdet.employee_id = aas.decommission_approved_by
        WHERE aas.status != '${AssetStatusEnum.RETIRED}' and aas.expired_Date < DATE(NOW())  `
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }

        if (req.aging != undefined) {
            if (req.aging == '1000') {
                getEntities = getEntities + ' having aging < 1000 '
            }
            if (req.aging == '1001-2000') {
                getEntities = getEntities + ' having aging between 1001 and 2000'
            }
            if (req.aging == '2001-3000') {
                getEntities = getEntities + ' having aging between 2001 and 3000'
            }
            if (req.aging == 'above 3000') {
                getEntities = getEntities + ' having aging > 3000'
            }
        }
        if (req.aging != undefined) {
            getEntities = getEntities + ``
        } else {
            getEntities = getEntities + ""
            // `ORDER BY aging DESC `
        }

        const data = await manager.query(getEntities)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }


    async assetDecommission(req: AssetsDto): Promise<CommonResponse> {
        try {
            const entity = await this.repo.findOne({ where: { assetsCode: req.assetsCode } })
            const manager = getManager()
            if (entity.status == 'INSTOCK') {
                if (entity) {
                    const convertedEntity = await this.repo.update({ assetId: entity.assetId }, { status: AssetStatusEnum.RETIRED, decommissionApprovedBy: req.decommissionApprovedBy })
                    const assetTransDto = new AssetTransactionDto();
                    assetTransDto.decommissionApprovedBy = req.decommissionApprovedBy;
                    assetTransDto.assetId = entity.assetId;
                    assetTransDto.status = AssetStatusEnum.RETIRED;
                    const assetTransEntity = this.assetTransactionAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
                    const assetTransctionSave = await this.assetTransactionRepo.save(assetTransEntity)
                    let qry = `SELECT a.asset_id , a.assets_code AS AssetCode , it.item_name AS assetName,asset_cost AS assetCost,decommission_approved_by , emp.employee_name AS approvedBy FROM ` + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = a.assets_name LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id = a.decommission_approved_by WHERE a.asset_id = ${entity.assetId}`;
                    const data = await manager.query(qry)
                    const parameters = [
                        { "type": "text", "text": moment().format('DD-MM-YYYY') },
                        { "type": "text", "text": data[0].assetName ? data[0].assetName : "No Data" },
                        { "type": "text", "text": data[0].AssetCode ? data[0].AssetCode : "No Data" },
                        { "type": "text", "text": data[0].assetCost ? Number(Number(data[0].assetCost).toFixed(0)).toLocaleString('en-IN') : "No Data" },
                        { "type": "text", "text": data[0].approvedBy ? data[0].approvedBy : "No Data" },
                    ];
                    for (const contact of whatsApp.contacts) {
                        let statusFlag = true
                        const req = await new MessageParameters(contact, 'asset_decommission', parameters, "en_us")
                        const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                        if (!messageStatus.status) {
                            statusFlag = false
                        }
                        else {
                            const testdata = 'INSERT INTO ' + appSettings.whatsapp_db + '.whatsapp_logs (contact_no,template_name,project_name,company_id,module_id) VALUES("' + contact + '","asset_decommission","Brandix_assets",' + GlobalVariableValues.companyId + ',' + GlobalVariableValues.assetManagementmoduleId + ')'
                            const result = await manager.query(testdata)
                            const res = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
                        }

                    }
                    return new CommonResponse(true, 1, 'Updated successfully')
                }

            } else {
                return new CommonResponse(false, 9989, 'You Cannot Retire the Asset')

            }
        } catch (err) {
            throw err;
        }
        // if (entity) {
        //     const convertedEntity = await this.repo.update({ assetId: entity.assetId }, { status: AssetStatusEnum.RETIRED, decommissionApprovedBy: req.decommissionApprovedBy })
        //     const assetTransDto = new AssetTransactionDto();
        //     assetTransDto.decommissionApprovedBy = req.decommissionApprovedBy;
        //     assetTransDto.assetId = entity.assetId;
        //     assetTransDto.status = AssetStatusEnum.RETIRED;
        //     const assetTransEntity = this.assetTransactionAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
        //     const assetTransctionSave = await this.assetTransactionRepo.save(assetTransEntity)
        //     return new CommonResponse(true, 1, 'Updated successfully')
        // } else {
        //     return new CommonResponse(false, 99899, 'No data found')
        // }

    }

    async assetCodeSearch(assetCode: AssetByCode): Promise<CommonResponse> {
        const getDto: AssetsDto[] = [];
        const assetObject: { asset_id: number } = await this.repo.createQueryBuilder('assets')
            .select('asset_id')
            .where(`assets_code = '${assetCode.assetsCode}'`)
            .getRawOne();
        const assetCodeStatus = Number(assetObject.asset_id)
        const Response = await this.repo.findOne({ where: { assetId: assetCodeStatus, status: AssetStatusEnum.INSTOCK } });
        if (Response) {
            const convertedDto: AssetsDto = this.adapter.convertAssetEntitytoDto(Response)
            const manager = getManager();
            const qry = `SELECT aas.asset_id, it.item_name AS assetname,its.item_sub_category AS assetCategory,lo.location_id ,loc.location_name FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_location_id = aas.asset_id LEFT JOIN ` + appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories its ON its.item_sub_category_id = aas.asset_category WHERE aas.asset_id = ${assetCodeStatus} ORDER BY it.item_name ASC`
            const data: { item_name: string, item_sub_category: string, location_name: string } = await manager.query(qry)
            convertedDto.itemName = data[0].assetname;
            convertedDto.itemSubCategoryName = data[0].assetCategory;
            convertedDto.currentLocationName = data[0].location_name;
            convertedDto.currentLocation = data[0].location_name;
            getDto.push(convertedDto);

            return new CommonResponse(true, 1, 'Data retrieved successfully', getDto)

        }
        else {
            return new CommonResponse(false, 99898, 'Asset Code not found')
        }
    }

    async getAbstractReport(): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT aas.asset_category,it.item_sub_category,SUM( IF(aas.STATUS='INSTOCK', 1 , 0)) AS Instock,
        SUM( IF(aas.STATUS='INUSE', 1 , 0)) AS checkin,
        SUM( IF(aas.STATUS='UNDERMAINTENANCE', 1 , 0)) AS undermaintainance ,
        SUM( IF(aas.STATUS='DAMAGED', 1 , 0)) AS damaged,
        SUM( IF(aas.STATUS='${AssetStatusEnum.RETIRED}', 1 , 0)) AS decommissioned,
        SUM( IF(aas.STATUS='${AssetStatusEnum.SERVICE}', 1 , 0)) AS service,
        SUM( IF(aas.STATUS='${AssetStatusEnum.INTRANSIT}', 1 , 0)) AS intransit,
        SUM( IF(aas.STATUS='${AssetStatusEnum.SOLD}', 1 , 0)) AS sold,
        COUNT(asset_category) AS total
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category
        GROUP BY asset_category`
        const data = await manager.query(qry);
        return new CommonResponse(true, 1, 'Data retrieevd Successfully', data)
    }

    async getDetailsByAbstract(req: AbstractDetails): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT isc.item_sub_category AS asset_category, aas.assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,
        locc.location_id,lo.location_id ,loc.location_name,aas.status,it.item_name FROM `+ appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        WHERE isc.item_sub_category = '${req.assetCategory}' AND aas.status = '${req.status}'
        ORDER BY assets_name ASC`;
        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, item_name: string
        }[] = await manager.query(qry)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.asset_category, data.asset_type))
        })
        return new CommonResponse(true, 1, 'Data retrieved Successfully', response)
    }


    @Cron('0 18 * * *')
    async getAssetTransactionalReport(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let assets = `SELECT COUNT(assets_name) AS assets FROM assets WHERE DATE(created_at)=DATE(NOW())`;
            let checkIn = `SELECT COUNT(asset_id) AS checkin FROM asset_assignment WHERE DATE(check_in) = DATE(NOW())`;
            let checkOut = `SELECT COUNT(asset_id) AS checkout FROM asset_assignment WHERE DATE(check_out) = DATE(NOW())`;
            let maintainance = `SELECT COUNT(asset_id) AS maintainance FROM asset_maintainance WHERE DATE(created_at) = DATE(NOW())`;
            let damaged = `SELECT COUNT( IF(STATUS='DAMAGED', 1 , 0)) AS damaged FROM assets WHERE DATE(updated_at) = DATE(NOW())`;
            let decommissioned = `SELECT COUNT( IF(STATUS='${AssetStatusEnum.RETIRED}', 1 , 0)) AS decommissioned FROM assets WHERE DATE(updated_at) = DATE(NOW())`;
            let warrenty = `SELECT COUNT(asset_id) AS warrenty_expired FROM assets WHERE DATE(warrenty_expired_date) = CURDATE()`;
            let insurance = `SELECT COUNT(asset_id) AS insurance_date FROM assets WHERE DATE(insurance_date) = CURDATE()`;
            const assetsProcured = await manager.query(assets);
            const todayCheckin = await manager.query(checkIn);
            const todayCheckout = await manager.query(checkOut);
            const todayMaintainance = await manager.query(maintainance);
            const todayDamaged = await manager.query(damaged);
            const todayDecommissioned = await manager.query(decommissioned);
            const warrentyExpired = await manager.query(warrenty);
            const insuranceExpired = await manager.query(insurance);
            const parameters = [
                { "type": "text", "text": moment().format('DD-MM-YYYY') },
                { "type": "text", "text": assetsProcured ? assetsProcured[0].assets : "No Data" },
                { "type": "text", "text": todayCheckin ? todayCheckin[0].checkin : "No Data" },
                { "type": "text", "text": todayCheckout ? todayCheckout[0].checkout : "No Data" },
                { "type": "text", "text": todayMaintainance ? todayMaintainance[0].maintainance : "No Data" },
                { "type": "text", "text": todayDamaged ? todayDamaged[0].damaged : "No Data" },
                { "type": "text", "text": todayDecommissioned ? todayDecommissioned[0].decommissioned : "No Data" },
                { "type": "text", "text": warrentyExpired ? warrentyExpired[0].warrenty_expired : "No Data" },
                { "type": "text", "text": insuranceExpired ? insuranceExpired[0].insurance_date : "No Data" },
            ];
            for (const contact of whatsApp.contacts) {
                let statusFlag = true
                const req = await new MessageParameters(contact, 'asset_transactional_report', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                if (!messageStatus.status) {
                    statusFlag = false
                } else {
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'asset_transactional_report', 'Brandix_assets', GlobalVariableValues.assetmanagementcompanyId, GlobalVariableValues.assetManagementmoduleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }

        } catch (err) {
            return new CommonResponse(false, 11108, "Error while sending message")
        }
    }

    async getTotalAbstract(req: AbstractDetails): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT isc.item_sub_category AS asset_category, aas.assets_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,it.item_name,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,
        locc.location_id,lo.location_id ,loc.location_name,aas.status FROM `+ appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        WHERE isc.item_sub_category = '${req.assetCategory}'
        ORDER BY assets_name ASC`;
        const assetdata: {
            asset_category: string, assets_name: number, assets_code: string, amc_available: string, date_of_purchased: Date,
            name: string, warrenty_expired_date: Date, insurance_date: Date, insurance: string, warrenty_available: string,
            expired_date: Date, asset_cost: number, status: AssetStatusEnum, asset_serialno: string, asset_condition: string, invoice: string, model: string,
            asset_supplier: string, item_id: number, grn_id: number, no_of_units: number, year: Date, units_of_measurements: string, last_checkin: Date, last_checkout: Date, amc_reason: string,
            asset_invoice_no: string, owner_of_asset: string, department: string, employee_id: number, maintenance_duedate: Date, transaction_date: Date, decommission_approved_by: string,
            service_tenure: string, insurance_provided_by: string, plant: string, asset_id: number, location_name: string, asset_type: string, item_name: string
        }[] = await manager.query(qry)

        const response = [];
        assetdata.forEach(data => {
            response.push(new AssetDto(data.asset_id, data.assets_name, data.assets_code, data.asset_serialno, data.item_id, data.grn_id,
                data.no_of_units, data.insurance, data.insurance_date, null, data.model, data.year,
                data.asset_supplier, data.asset_invoice_no, data.expired_date, data.asset_cost, data.date_of_purchased, data.asset_category, data.status, data.asset_condition, data.amc_available, data.name,
                null, data.owner_of_asset, data.units_of_measurements, data.location_name, data.last_checkin, data.last_checkout, data.warrenty_available, data.warrenty_expired_date,
                data.employee_id, data.department, data.maintenance_duedate, data.transaction_date, null, true, data.item_name, null, 1, data.decommission_approved_by,
                data.service_tenure, data.insurance_provided_by, data.plant, data.amc_reason, data.asset_category, data.asset_type))
        })
        return new CommonResponse(true, 1, 'Data retrieved Successfully', response)
    }

    async historyReport(req: AssetByStatus): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            const query = `SELECT aas.assets_name,it.item_name,aas.asset_serialno,aas.name,aas.assets_code,aas.insurance_date,aas.model,aas.year,aas.expired_date,aas.asset_cost,aas.date_of_purchased,aas.asset_category,its.item_sub_category,aas.status,aas.warrenty_expired_date,aas.owner_of_asset,em.employee_name,loc.location_name
            FROM `+ appSettings.assets_db + `.assets aas 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories its ON its.item_sub_category_id = aas.asset_category 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = aas.owner_of_asset 
            LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
            LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
            LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
            WHERE aas.assets_code = '${req.assetCode}' OR aas.created_at BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            const dropData = await manager.query(query)
            data.push(dropData);
            const locationQuery = `SELECT aas.asset_category,aas.assets_name,it.item_name,isc.item_sub_category,ass.asset_location_transaction_id,ass.asset_id,ass.asset_location_id,ass.location_id,loc.location_name,aas.assets_code 
            FROM `+ appSettings.assets_db + `.asset_location_transactions ass 
            LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = ass.location_id 
            LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.assets_name = ass.asset_id 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
            WHERE aas.assets_code = '${req.assetCode}' OR ass.created_at BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            const dropData1 = await manager.query(locationQuery)
            data.push(dropData1)
            const assignmentQuery = `SELECT aas.assets_name,it.item_name,assign.asset_assignment_id,assign.asset_id,assign.employee_id,assign.check_in,assign.checkin_reason,assign.check_out,assign.checkout_reason,em.employee_name,em.mobile_no
            FROM `+ appSettings.assets_db + `.asset_assignment_transactions assign 
            LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.assets_name = assign.asset_id 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = assign.employee_id 
            WHERE aas.assets_code = '${req.assetCode}' OR assign.created_at BETWEEN '${req.fromDate}' AND '${req.toDate}' ORDER BY DATE(NOW())`
            const dropData2 = await manager.query(assignmentQuery)
            data.push(dropData2)
            const maintainanceQuery = `SELECT aas.assets_code,aas.owner_of_asset,aas.assets_name,am.asset_maintainance_id,am.asset_id,am.maintainance_type,am.cost_of_repair,am.damage_reason,am.created_at,am.updated_at,it.item_name,em.employee_name
            FROM `+ appSettings.assets_db + `.asset_maintainance_transactions am 
            LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = am.asset_id 
            LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name 
            LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id = aas.owner_of_asset
            WHERE aas.assets_code = '${req.assetCode}' OR am.created_at BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            const dropData3 = await manager.query(maintainanceQuery)
            data.push(dropData3)
            if (data) {
                return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
            } else {
                return new CommonResponse(true, 11608, 'Somethig Went Wrong')
            }
        } catch (error) {
            return error;
        }
    }

    async createAssetService(createDto: AssetServiceDto | any): Promise<CommonResponse> {
        const transactionManager = new GenericTransactionManager
        try {
            await transactionManager.startTransaction()
            const manager = getManager()
            let plannedResult
            let unplannedResult
            if (createDto.serviceType == 'planned') {
                plannedResult = await this.createPlannedServiceEntries(createDto, transactionManager)

            } else {
                console.log(createDto, 'createDto')
                const entity = this.assetServiceAdapter.convertDtoToEntity(createDto);
                unplannedResult = await transactionManager.getCustomRepository(AssetServiceRepository).save(entity)
                for (const id of createDto.assetId) {
                    const assetCheck = await this.repo.findOne({ where: { assetId: id } })
                    if (assetCheck) {
                        const assetServiceDate = await this.repo.update({ assetId: assetCheck.assetId }, { assetServiceDate: createDto.assetServiceDate, status: AssetStatusEnum.SERVICE })
                        const assetTransDto = new AssetTransactionDto();
                        assetTransDto.assetId = assetCheck.assetId;
                        assetTransDto.assetServiceDate = createDto.assetServiceDate;
                        assetTransDto.serviceName = createDto.serviceName;
                        assetTransDto.status = AssetStatusEnum.SERVICE;
                        const assetTransEntity = this.assetTransactionAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
                        const assetTransSave = await transactionManager.getRepository(AssetTransaction).save(assetTransEntity)
                    }
                }

                // whatsapp message trigger 

            }
            console.log(plannedResult,'planned result')
            console.log(unplannedResult)
            await transactionManager.completeTransaction()
            if (createDto.serviceType == 'planned') {

                const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.model,asr.asset_service_date as serviceDate,asr.phone_number as phoneNumber,asr.service_owner as serviceOwner,i.item_name as itemName,a.assets_code as assetCode,asr.service_owner as serviceOwner,asr.remarks,asr.asset_serve_id as serviceId from ${appSettings.assets_db}.asset_service asr
                left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
                left join ${appSettings.masters_db}.items i  on i.item_id = a.assets_name
                where asr.asset_serve_id = ${plannedResult.data.assetServeId}`
                const data = await manager.query(todaysServices)
                const msgText = `*${data[0].serviceOwner}*, \\n \\n*${data[0].serviceName}* - A ${createDto.frequencyOfService} recurring service for the asset *${data[0].itemName} - ${data[0].assetCode}* is scheduled between *${moment(createDto.startDate).format('MMMM Do YYYY')}* and *${moment(createDto.endDate).format('MMMM Do YYYY')}* \\nService status : *OPEN* \\nService note : ${data[0].remarks}\\n`
                const waParameters = [{ type: 'text', text: msgText }]
                for (const contact of whatsApp.contacts) {
                    const msgParameters = new MessageParameters(contact, 'service_notify', waParameters, 'en_us', data[0].serviceId)
                    const sendMessage = await this.wpService.sendMessageWithButtonParamsThroughFbApi(msgParameters)
                }
            } else {
                const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.model,asr.asset_service_date as serviceDate,asr.phone_number as phoneNumber,asr.service_owner as serviceOwner,i.item_name as itemName,a.assets_code as assetCode,asr.service_owner as serviceOwner,asr.remarks,asr.asset_serve_id as serviceId from ${appSettings.assets_db}.asset_service asr
                left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
                left join ${appSettings.masters_db}.items i  on i.item_id = a.assets_name
                where asr.asset_serve_id = ${unplannedResult[0].assetServeId}`
                const data = await manager.query(todaysServices)
                const msgText = `*${data[0].serviceOwner}*, \\n \\n*${data[0].serviceName}* - service for the asset *${data[0].itemName} - ${data[0].assetCode}* is scheduled on *${moment(data[0].serviceDate).format('MMMM Do YYYY')}* \\nService status : *OPEN* \\nService note : ${data[0].remarks}\\n`
                const waParameters = [{ type: 'text', text: msgText }]
                for (const contact of whatsApp.contacts) {
                    const msgParameters = new MessageParameters(contact, 'service_notify', waParameters, 'en_us', data[0].serviceId)
                    const sendMessage = await this.wpService.sendMessageWithButtonParamsThroughFbApi(msgParameters)
                }
            }
            return new CommonResponse(true, 11608, 'Successfully Created')
        } catch (err) {
            console.log(err)
            await transactionManager.releaseTransaction()
            throw err

        }
    }


    async getAllAssetsDataById(req?: AssetsId): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT isc.item_sub_category AS assetCategory, it.item_name AS assetName,aas.assets_code AS assetsCode,aas.amc_available ,aas.date_of_purchased AS dateOfPurchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost AS assetCost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,aas.decommission_approved_by,DATE_ADD( aas.date_of_purchased,INTERVAL aas.service_tenure DAY ) AS actAssetServiceDate,
        aas.service_tenure AS serviceTenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id AS assetId,unc.unit_name AS plant,
        TIMESTAMPDIFF(YEAR,aas.date_of_purchased,DATE(NOW())) AS yeardiff,
        locc.location_id,lo.location_id ,loc.location_name,aas.asset_category as assetCategoryId FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        where aas.asset_id > 0 AND aas.asset_id = '${req?.assetId}'
        ORDER BY date_of_purchased DESC`;
        const data = await manager.query(query)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }

    async getAsssetForCategory(req?: AssetsCatagoryByIdDto): Promise<CommonResponse> {
        const manager = getManager()
        let query;
        query = `select a.assets_name as assetName,a.assets_code as assetCode,a.asset_id as assetId,i.item_name as itemName,concat(i.item_name,'-',a.assets_code) as name from ${appSettings.assets_db}.assets a 
        left join ${appSettings.masters_db}.items i on i.item_id = a.assets_name
         where a.asset_id > 0  `
        if (req.unitId != 5) {
            query = query + ` and plant = ${req.unitId}`
        }
        if (req.assetsCatagoryId) {
            query = query + ` and a.asset_category = ${req.assetsCatagoryId}`
        }
        if (req.departmentId) {
            query = query + ` and a.department = ${req.departmentId}`
        }
        const data = await manager.query(query)
        if (data && data.length) return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        return new CommonResponse(false, 11608, 'Data not found')
    }

    async getAssetServiceReportdata(req?: AssetServiceRportReq): Promise<CommonResponse> {
        const manager = getManager();
        let query;
        query = 'SELECT asr.asset_service_date AS actualserviceDate,asr.service_name AS serviceName,asr.status AS serviceStatus,DATE_ADD( a.created_at,INTERVAL a.service_tenure DAY ) AS serviceDate,isc.item_sub_category AS categoryName,DATE(warrenty_expired_date) AS warantyExpiredDate,i.item_name AS assetName,ed.employee_name AS assetOwner,uc.unit_name AS plantName,asset_cost AS assetCost,isc.item_sub_category AS assetCategory,l.location_name AS locationName,assets_name AS assetId,assets_code AS assetCode,DATE(expired_date) AS expiredDate,DATE(asr.asset_service_date) AS actuallassetServiceDate,a.plant AS plantId,DATE(insurance_date) AS insuranceDate,asset_cost AS assetCose,DATE(date_of_purchased) AS purchasedDate ,a.asset_type AS assetType FROM  ' + appSettings.assets_db + '.asset_service asr  LEFT JOIN ' + appSettings.assets_db + '.assets a ON a.asset_id=asr.asset_id LEFT  JOIN ' + appSettings.assets_db + '.asset_location_mapping al ON a.asset_id=al.asset_id LEFT JOIN ' + appSettings.assets_db + '.location l ON l.location_id = al.location_id LEFT JOIN ' + appSettings.masters_db + '.unitcodes uc ON uc.unit_code_id=a.plant  LEFT JOIN ' + appSettings.masters_db + '.employee_details ed ON ed.employee_id=a.owner_of_asset LEFT JOIN ' + appSettings.masters_db + '.items i ON i.item_id=a.assets_name left join ' + appSettings.masters_db + '.item_sub_categories isc on isc.item_sub_category_id=a.asset_category WHERE a.asset_id >0 '

        if (req.assetCode) {
            query = query + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.plant != 5) {
            query = query + ' and a.plant = ' + req.plant + ''
        }
        if (req.location) {
            query = query + ' and l.location_id =' + req.location + ''
        }
        if (req.assetCategory) {
            query = query + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.assetCategory && req.assetCode && req.location && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and a.plant = ' + req.plant + ' and l.location_id =' + req.location + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.assetCode && req.location) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '" and l.location_id =' + req.location + ''
        }
        const result = await manager.query(query)
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        } else {
            return new CommonResponse(false, 11608, 'No data Foun', result)
        }
    }
    async getcategorydropdown(): Promise<CommonResponse> {
        const manager = getManager();
        const Query = 'SELECT asset_category_id AS assetCategoryId,category_name AS categoryName FROM `asset_category`';
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Foun', result)
        }

    }
    async getLocationdropdown(): Promise<CommonResponse> {
        const manager = getManager();
        const Query = ' SELECT location_id locationId,location_name AS locationName FROM `location`';
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Foun', result)
        }

    }

    async assetHistoryInformation(req: AssetByCode): Promise<CommonResponse> {
        const assetLocationMappingObj: { asset_id: number, asset_location_id: number } = await this.locationMapRepo.createQueryBuilder('asset_loc')
            .select('assets.asset_id, asset_location_id')
            .leftJoin('asset_loc.assetsId', 'assets')
            .where(`assets.assets_code = '${req.assetsCode}'`)
            .getRawOne();
        const actAssetId = Number(assetLocationMappingObj.asset_id);
        const manager = getManager();
        const query = `SELECT * FROM (SELECT asset_id ,created_at ,STATUS FROM ` + appSettings.assets_db + `.assets 
        UNION ALL SELECT asset_id , created_at ,STATUS FROM ` + appSettings.assets_db + `.asset_location_transactions 
        UNION ALL SELECT asset_id , created_at,STATUS FROM ` + appSettings.assets_db + `.asset_assignment_transactions 
        UNION ALL SELECT asset_id , created_at,STATUS FROM ` + appSettings.assets_db + `.asset_maintainance_transactions UNION ALL
        SELECT asset_id , created_at,service_name AS STATUS FROM ` + appSettings.assets_db + `.asset_service) AS asset 
        WHERE asset_id = '${actAssetId}' ORDER BY created_at`
        const data: { asset_id: number, deptName: string, employeeName: string, costOfRepair: string, created_at: string, STATUS: string }[] = await manager.query(query)
        const dataToSent = []
        for (const assetData of data) {
            const assetRemDataQuery = `SELECT aas.asset_id ,d.dept_name,em.employee_name,am.cost_of_repair FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.assets_db + `.asset_maintainance_transactions am ON am.asset_maintainance_transactions_id = aas.asset_id LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = em.department_id  WHERE aas.asset_id = '${assetData.asset_id}' LIMIT 1`;
            const assetRemData: any[] = await manager.query(assetRemDataQuery)
            assetData.deptName = assetRemData['dept_name'];
            assetData.employeeName = assetRemData['employee_name'];
            assetData.costOfRepair = assetRemData['cost_of_repair'];
            dataToSent.push({
                assetId: assetData.asset_id,
                createdAt: assetData.created_at,
                status: assetData.STATUS,
                deptName: assetRemData[0].dept_name,
                employeeName: assetRemData[0].employee_name,
                costOfRepair: assetRemData[0].cost_of_repair
            })
        }
        if (dataToSent.length) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', dataToSent)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }

    async getDecommissioneddAssetsReport(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT isc.item_sub_category AS asset_category, it.item_name AS assets_name,aas.assets_code AS assetsCode,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.assets_name as item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,empdet.employee_name AS decommission_approved_by,aas.updated_at,datediff(date(now()),date_of_purchased) as aging,aas.asset_mode FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empdet ON empdet.employee_id = aas.decommission_approved_by
        WHERE aas.status = '${AssetStatusEnum.RETIRED}'`
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        // if(req.plant){
        //     getEntities = getEntities + 'and unc.unit_name = "' + req.plant +'"'
        // }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.fromDate) {
            getEntities = getEntities + 'and aas.updated_at BETWEEN "' + req.fromDate + '" AND "' + req.toDate + '"'
        }
        // if(req.plant && req.location){
        //     getEntities = getEntities + 'and unc.unit_name = "' + req.plant +'" and loc.location_name = "' + req.location +'"'
        // }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and assi.employee_id = "' + req.employeeId + '"'
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_name = "' + req.department + '"'
        }
        if (req.fromDate) {
            getEntities = getEntities + ` ORDER BY aas.updated_at ASC `
        } else {
            getEntities = getEntities + ` ORDER BY it.item_name ASC `
        }

        const data = await manager.query(getEntities)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }

    async getDecommissioneddAssetsReportDropdown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT isc.item_sub_category AS asset_category, it.item_name AS assets_name,aas.assets_code AS assetsCode,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,emp.employee_name AS owner_of_asset,aas.transaction_date,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,unc.unit_name AS plant,aas.asset_type,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_type,aas.service_status,aas.amc_provider,
        locc.location_id,lo.location_id ,loc.location_name,empdet.employee_name AS decommission_approved_by,aas.updated_at FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empdet ON empdet.employee_id = aas.decommission_approved_by
        WHERE aas.status = '${AssetStatusEnum.RETIRED}' `
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` ORDER BY it.item_name ASC `

        const data = await manager.query(getEntities)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }
    }

    async assetsTopServices(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = `SELECT aa.assets_code,aas.asset_service_date , it.item_name AS asset_name,a.plant,u.unit_name AS unit,DATEDIFF(aas.asset_service_date,DATE(NOW())) AS aging FROM ` + appSettings.assets_db + `.asset_service aas LEFT JOIN ` + appSettings.assets_db + `.assets aa ON aa.asset_id = aas.asset_id LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aa.assets_name LEFT JOIN ` + appSettings.assets_db + `.assets a ON a.asset_id = aas.asset_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant WHERE aas.asset_service_date IS NOT NULL AND aas.asset_service_date >DATE(NOW()) ORDER BY asset_service_date ASC LIMIT 5`
            const dropData = await manager.query(qry)
            data.push(dropData)

            if (dropData) {

                return new CommonResponse(true, 1, ' Data retrievd successfully', data)
            } else {
                return new CommonResponse(false, 99898, 'Something went wrong')
            }
        } catch (error) {
            return error
        }
    }

    async getAssetCodesDropDown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT i.item_name AS assetName,assets_name AS assetId,assets_code AS assetsCode,CONCAT(i.item_name,"-",assets_code) AS concateditemName FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.items i ON a.assets_name=i.item_id WHERE STATUS IN ("INSTOCK","INUSE") `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }

    }

    async getInstockAssetCodesDropDown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT i.item_name AS assetName,assets_name AS assetId,assets_code AS assetsCode,CONCAT(i.item_name,"-",assets_code) AS concateditemName FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.items i ON a.assets_name=i.item_id WHERE STATUS IN ("INSTOCK") `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }
    }

    async getRentedAssetCodesDropDown(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT i.item_name AS assetName,assets_name AS assetId,assets_code AS assetsCode,CONCAT(i.item_name,"-",assets_code) AS concateditemName FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.items i ON a.assets_name=i.item_id WHERE asset_mode = 'rentedAsset' and status = '${AssetStatusEnum.INSTOCK}' `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }

    }

    async updateAssetStatus(req: AssetByCode): Promise<CommonResponse> {
        try {
            const updateDate = req.status == ServiceStatusEnum.INPROGRESS ? { startDate: new Date() } : { completedDate: new Date() }
            const serviceText = req.status == ServiceStatusEnum.INPROGRESS ? 'is started' : 'is completed'
            let updateStatus = await this.assetServiceRepo.update({ assetServeId: req.assetServiceId }, { status: req.status, ...updateDate });
            if (req.status == ServiceStatusEnum.COMPLETE) {
                const assetUpdateStatus = await this.repo.update({ assetId: Number(req.assetsCode) }, { status: AssetStatusEnum.INSTOCK })
                // const assetObj: { asset_id: number} = await this.repo.createQueryBuilder('assets')
                // .select('assets.asset_id')
                // .where(`assets.assets_code = '${req.assetsCode}'`)
                // .getRawOne();
                // const actAssetId = Number(assetObj.asset_id);
                const assetTransDto = new AssetTransactionDto();
                assetTransDto.assetId = Number(req.assetsCode);
                assetTransDto.status = AssetStatusEnum.INSTOCK;
                const assetTransEntity = this.assetTransactionAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
                const assetTransSave = await this.assetTransactionRepo.save(assetTransEntity)
            }
            const manager = getManager()
            const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.model,asr.asset_service_date as serviceDate,asr.phone_number as phoneNumber,asr.service_owner as serviceOwner,i.item_name as itemName,a.assets_code as assetCode,asr.service_owner as serviceOwner,asr.remarks,asr.asset_serve_id as serviceId from ${appSettings.assets_db}.asset_service asr
            left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
            left join ${appSettings.masters_db}.items i  on i.item_id = a.assets_name
            where asr.asset_serve_id = ${req.assetServiceId}`
            const data = await manager.query(todaysServices)
            const msgText = `*${data[0].serviceOwner}*,\\n ${data[0].serviceName} - service ${serviceText} for the asset *${data[0].itemName} - ${data[0].assetCode}* \\n Service status : *${req.status}* \\n Service note : ${data[0].remarks}`
            const waParameters = [{ type: 'text', text: msgText }]
            for (const contact of whatsApp.contacts) {
                const msgParameters = new MessageParameters(contact, 'service_notify', waParameters, 'en_us', data[0].serviceId)
                const sendMessage = await this.wpService.sendMessageWithButtonParamsThroughFbApi(msgParameters)
            }
            if (updateStatus.affected > 0) {
                return new CommonResponse(true, 1001, "Status updated Successfully.");
            }
            else {
                return new CommonResponse(false, 1010, "Something went wrong.");
            }
        } catch (error) {
            return error
        }
    }
    async underMaintainanceOnInternal(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT COUNT(a.asset_id) AS COUNT,a.assets_code AS assetsCode,it.item_name AS assetName,u.unit_name AS unit FROM ' + appSettings.assets_db + '.`asset_maintainance` am LEFT JOIN ' + appSettings.assets_db + '.`assets` a ON a.asset_id = am.asset_id LEFT JOIN ' + appSettings.masters_db + '.items it ON it.item_id = a.assets_name LEFT JOIN ' + appSettings.assets_db + '.`asset_service` ass ON ass.asset_id = am.asset_id LEFT JOIN ' + appSettings.masters_db + '.`unitcodes` u ON u.unit_code_id = a.plant WHERE am.status = "UNDERMAINTENANCE" GROUP BY a.asset_id ORDER BY COUNT(a.asset_id) DESC LIMIT 5'
        // if (req.plantId > 0 && req.plantId != 5) {
        //     Query = Query + 'and a.plant = ' + req.plantId + ' LIMIT 5'
        // }
        // Query = Query + ` LIMIT 5`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }
    }

    async underMaintainanceOnVendor(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT a.assets_code AS assetsCode,ass.asset_name AS assetName,a.asset_supplier AS assetSupplier,u.unit_name AS unit FROM ' + appSettings.assets_db + '.assets a LEFT JOIN `erpx_dev_assets`.`asset_service` ass ON ass.asset_id = a.asset_id LEFT JOIN ' + appSettings.masters_db + '.unitcodes u ON u.unit_code_id = a.plant WHERE ass.asset_name IS NOT NULL'
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId + ' LIMIT 5'
        }
        Query = Query + ` LIMIT 5`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }
    }

    async getPlantWiseAssets(): Promise<CommonResponse> {
        const manager = getManager();
        const qry = `SELECT aas.plant ,unc.unit_name AS plantname,SUM( IF(aas.STATUS='INSTOCK', 1 , 0)) AS Instock,
        SUM( IF(aas.STATUS='INUSE', 1 , 0)) AS checkin,
        SUM( IF(aas.STATUS='UNDERMAINTENANCE', 1 , 0)) AS undermaintainance ,
        SUM( IF(aas.STATUS='DAMAGED', 1 , 0)) AS damaged,
        SUM( IF(aas.STATUS='${AssetStatusEnum.RETIRED}', 1 , 0)) AS decommissioned
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant
        GROUP BY plant`
        const data = await manager.query(qry);
        return new CommonResponse(true, 1, 'Data retrieevd Successfully', data)
    }

    async getpurchasedbutnotAssigned(): Promise<CommonResponse> {
        const manager = getManager();
        const query = 'SELECT last_checkin,plant,unit_name AS plantName,COUNT(asset_id) AS totalassets FROM ' + appSettings.assets_db + '.`assets` a LEFT JOIN ' + appSettings.masters_db + '.unitcodes u ON u.unit_code_id=a.plant WHERE STATUS="INSTOCK" GROUP BY plant'
        const data = await manager.query(query)
        if (data) {
            return new CommonResponse(true, 1000, 'Data retrived sucessfully', data)
        } else {
            return new CommonResponse(false, 1000, 'no data found')

        }
    }

    async getPurchasedDetailsUnused(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT location_name AS locationName,isc.item_sub_category AS asetCategoryName,u.unit_name AS plant,i.item_name AS assetName,assets_name AS assetId,assets_code AS assetCode,DATE(date_of_purchased) AS purchaseddate,STATUS AS STATUS, aas.plant AS plantId ,aas.asset_type, asset_condition AS assetCondition,DATEDIFF(DATE(NOW()),date_of_purchased) AS aging 
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN ` + appSettings.masters_db + `.items i ON aas.assets_name = i.item_id 
        LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category 
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=aas.plant 
        LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN ` + appSettings.assets_db + `.asset_location_mapping al ON al.asset_id=aas.asset_id 
        LEFT JOIN ` + appSettings.assets_db + `.location l ON l.location_id=al.location_id WHERE STATUS="INSTOCK" `
        if (req.plantId && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.assetCode) {
            getEntities = getEntities + 'and assets_code = "' + req.assetCode + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and plant = "' + req.plant + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }

        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.aging != undefined) {
            if (req.aging == '50') {
                getEntities = getEntities + ' having aging < 50 '
            }
            if (req.aging == '51-300') {
                getEntities = getEntities + ' having aging between 51 and 300'
            }
            if (req.aging == '301-900') {
                getEntities = getEntities + ' having aging between 301 and 900'
            }
            if (req.aging == '901-1500') {
                getEntities = getEntities + ' having aging between 901 and 1500'
            }
            if (req.aging == '1501-2125') {
                getEntities = getEntities + ' having aging between 1096 and 2125'
            }
            if (req.aging == '2125-3000') {
                getEntities = getEntities + '  having aging between 2125 and 3000'
            }
            if (req.aging == '3000-3600') {
                getEntities = getEntities + '  having aging between 3000 and 3600'
            }
            if (req.aging == '3600-4200') {
                getEntities = getEntities + '  having aging between 3600 and 4200'
            }
            if (req.aging == 'above 4200') {
                getEntities = getEntities + ' having aging > 4200'
            }
        }
        if (req.aging != undefined) {
            getEntities = getEntities + ` ORDER BY aging ASC`
        } else {
            getEntities = getEntities + ` ORDER BY i.item_name ASC`
        }
        const result = await manager.query(getEntities)
        if (result) {
            return new CommonResponse(true, 1, 'Data retrieved', result)

        } else {
            return new CommonResponse(false, 1, 'Data not found')

        }
    }

    async getAssignedforRent(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT a.asset_mode AS assetMode, a.status AS STATUS,a.assets_code AS assetCode,a.assets_name AS assetId,a.plant AS plantId ,uc.unit_name AS plant ,l.location_id AS locationId ,i.item_name AS assetName ,l.location_name AS locationName,DATE (a.date_of_purchased) AS date_of_purchased,i.asset_type AS assetType,a.rental_cost AS rentalCost,ic.item_sub_category AS assetCategory ,a.asset_condition AS asset_condition,a.month AS MONTH , a.day AS DAY , 
        a.asset_rent_period AS asset_rent_period , a.asset_rent_tenure_type AS asset_rent_tenure_type , a.rental_cost_type AS rental_cost_type ,
   a.rental_cost AS rental_cost,
IF (a.asset_rent_tenure_type ='Days' AND a.rental_cost_type != 'totalRent' , 1*a.rental_cost*a.asset_rent_period,
IF (a.asset_rent_tenure_type ='Month' AND a.rental_cost_type != 'totalRent', 30*a.rental_cost*a.asset_rent_period,
IF (a.asset_rent_tenure_type ='Year' AND a.rental_cost_type = 'perMonth',  12*a.rental_cost*a.asset_rent_period ,
IF (a.asset_rent_tenure_type ='Year' AND a.rental_cost_type = 'perDay',  365*a.rental_cost*a.asset_rent_period ,a.rental_cost)))) AS result,
  CASE
  WHEN a.asset_rent_tenure_type ='Days' THEN DATEDIFF(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period DAY), NOW())
  WHEN a.asset_rent_tenure_type ='Month' THEN DATEDIFF(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period MONTH), NOW())
  WHEN a.asset_rent_tenure_type ='Year' THEN DATEDIFF(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period YEAR), NOW())
  ELSE NULL
  
  END AS days_between, 
 CASE
        WHEN a.asset_rent_tenure_type = 'Days' THEN DATE(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period DAY))
        WHEN a.asset_rent_tenure_type = 'Month' THEN DATE(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period MONTH))
        WHEN a.asset_rent_tenure_type = 'Year' THEN DATE(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period YEAR))
    END AS end_date
         FROM   ` + appSettings.assets_db + ` .assets a 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN ` + appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = a.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE asset_mode = 'rentedAsset'AND STATUS='INSTOCK'`
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + ' and a.plant = ' + req.plantId
        }
        if (req.assetCode) {
            getEntities = getEntities + 'and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant) {
            getEntities = getEntities + 'and uc.unit_name = "' + req.plant + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and ic.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.result != undefined) {
            if (req.result == '300') {
                getEntities = getEntities + ' having result < 300 '
            }
            if (req.result == '301-5000') {
                getEntities = getEntities + ' having result between 300 and 5000'
            }
            if (req.result == '5001-50000') {
                getEntities = getEntities + ' having result between 5000 and 50000'
            }
            if (req.result == '50001-100000') {
                getEntities = getEntities + ' having result between 50001 and 100000'
            }
            if (req.result == '100001-200000') {
                getEntities = getEntities + ' having result between 100001 and 200000'
            }
            if (req.result == '200001-500000') {
                getEntities = getEntities + '  having result between 200001 and 500000'
            }
            if (req.result == '500001-100000') {
                getEntities = getEntities + '  having aging between 500001 and 100000'
            }
            if (req.result == 'above 1000000') {
                getEntities = getEntities + ' having result > 1000000'
            }
        }

        // getEntities = getEntities + ` GROUP BY a.assets_code `
        if (req.days_between != undefined) {
            if (req.days_between == '50') {
                getEntities = getEntities + ' having days_between < 50 '
            }
            if (req.days_between == '0-90') {
                getEntities = getEntities + ' having days_between between 0 and 90'
            }
            if (req.days_between == '0-180') {
                getEntities = getEntities + ' having days_between between 0 and 180'
            }
            if (req.days_between == '0-365') {
                getEntities = getEntities + ' having days_between between 0 and 365'
            }
            if (req.days_between == '0-1095') {
                getEntities = getEntities + ' having days_between between 0 and 1095'
            }
            if (req.days_between == '0-1825') {
                getEntities = getEntities + '  having days_between between 0 and 1825'
            }
            if (req.days_between == 'above 1825') {
                getEntities = getEntities + '  having days_between > 1825'
            }
            // if (req.days_between == '3600-4200') {
            //     getEntities = getEntities + '  having days_between between 3600 and 4200'
            // }
            // if (req.days_between == 'above 4200') {
            //     getEntities = getEntities + ' having days_between > 4200'
            // }
        }
        if (req.result != undefined) {
            getEntities = getEntities + ` ORDER BY result ASC`
        }
        else if (req.days_between != undefined) {
            getEntities = getEntities + ` ORDER BY days_between ASC`
        } else {
            getEntities = getEntities + ` ORDER BY i.item_name ASC`
        }

        const response = await manager.query(getEntities);
        return new CommonResponse(true, 1, 'Data retrieved', response)
    }


    async createPlannedServiceEntries(req: Assets | AssetServiceDto | any, transactionManager: GenericTransactionManager): Promise<CommonResponse> {
        try {
            let dates: string[]
            var startDate = moment(req.startDate)
            var endDate = moment(req.endDate)
            const months = endDate.diff(startDate, 'months')
            switch (req.frequencyOfService) {
                case ServiceFrequency.Weekly:
                    dates = await this.assetServiceHelper.getDaysForWeeklyFrequency(req.day, 7, req.startDate, req.endDate)
                    break;
                case ServiceFrequency.FortWeekly:
                    dates = await this.assetServiceHelper.getDaysForWeeklyFrequency(req.day, 14, req.startDate, req.endDate)
                    break;
                case ServiceFrequency.Weekend:
                    dates = await this.assetServiceHelper.getThirdAndFourthSundaysBetweenDates(req.startDate, req.endDate)
                    break;
                case ServiceFrequency.Monthly:
                    const today = moment().date(Number(req.day)).format("YYYY-MM-DD")
                    dates = await this.assetServiceHelper.getMonthlyDates(new Date(today), months)
                    break;
                case ServiceFrequency.QuarterYearly:
                    dates = await this.assetServiceHelper.getQuarterlyDates(req.month, 4)
                    break;
                case ServiceFrequency.HalfYearly:
                    dates = await this.assetServiceHelper.getHalfyearlyDates(req.month, 2)
                    break;
                case ServiceFrequency.Yearly:
                    dates = await this.assetServiceHelper.getYearlyDates(req.month, 1)
                    break;
                case ServiceFrequency.Daily:
                    dates = await this.assetServiceHelper.getDailyFrequency(req.startDate, req.endDate)

            }

            const flag = new Set()
            let createService
            let plannedResult
            const assetsArr: AssetService[] = []
            for (const date of dates) {
                for (const assetVal of req.assetId) {

                    const jsDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
                    const assetServiceDto = new AssetServiceDto()
                    assetServiceDto.actAssetServiceDate = new Date()
                    assetServiceDto.assetCategory = req.assetCategory;
                    assetServiceDto.assetId = assetVal;
                    assetServiceDto.assetName = req.assetName;
                    assetServiceDto.frequencyOfService = req.frequencyOfService;
                    assetServiceDto.dateOfPurchased = req.dateOfPurchased;
                    assetServiceDto.createdUser = req.createdUser;
                    assetServiceDto.status = ServiceStatusEnum.OPEN;
                    assetServiceDto.assetServiceDate = new Date(date)
                    assetServiceDto.actAssetServiceDate = new Date(date)
                    assetServiceDto.serviceName = req.serviceName
                    assetServiceDto.serviceType = req.serviceType
                    assetServiceDto.month = req.month
                    assetServiceDto.day = req.day
                    assetServiceDto.phoneNumber = req.phoneNumber
                    assetServiceDto.remarks = req.remarks;
                    assetServiceDto.serviceOwner = req.serviceOwner;
                    assetServiceDto.serviceProvider = req.serviceProvider;
                    const checkListEntity: AssetServiceChecklistDto[] = []
                    for (const element of req.assetServiceChecklist) {
                        const assetServiceChecklistEnt = new AssetServiceChecklist()
                        assetServiceChecklistEnt.checklist = element.checklist
                        assetServiceChecklistEnt.checklistStatus = element.checklistStatus
                        assetServiceChecklistEnt.createdUser = element.createdUser;
                        checkListEntity.push(assetServiceChecklistEnt)
                    }
                    assetServiceDto.assetServiceChecklist = checkListEntity;
                    console.log(assetServiceDto,'assetServiceDto')
                    createService = await transactionManager.getCustomRepository(AssetServiceRepository).save(assetServiceDto)
                    console.log(createService,'createService');
                    if (!createService) {
                        flag.add(false)
                        throw new ErrorResponse(1111, 'Error while creating')
                    }
                }
            }
            return new CommonResponse(true, 1111, 'Service created sucessfully', createService)
        } catch {
            await transactionManager.releaseTransaction()
        }
    }


    async getAgeWiseAssets(): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT plant,unit_name AS plantName,COUNT(asset_id) AS purchasedButNotAssigned,SUM(IF(date_of_purchased >= DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 3 MONTH), '%Y-%m-01'), 1, 0)) AS last3months ,SUM(IF(date_of_purchased < DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 3 MONTH), '%Y-%m-01') AND date_of_purchased > DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 6 MONTH), '%Y-%m-01'), 1, 0)) AS threeTo6months,SUM(IF(date_of_purchased < DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 6 MONTH), '%Y-%m-01') AND date_of_purchased > DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 12 MONTH), '%Y-%m-01'), 1, 0)) AS sixTo12months ,SUM(IF(date_of_purchased < DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 12 MONTH), '%Y-%m-01'), 1, 0)) AS yearbefore FROM ` + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=a.plant WHERE STATUS = "INSTOCK" GROUP BY plant`
        const data = await manager.query(query)

        if (data) {
            return new CommonResponse(true, 1000, 'Data retrived sucessfully', data)
        } else {
            return new CommonResponse(false, 1000, 'no data found')

        }
    }

    async getSkippedAssetsCount(): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT SUM(IF(aas.status ='OPEN',1,0)) AS assets ,a.plant,u.unit_name AS plantName FROM ` + appSettings.assets_db + `.asset_service aas LEFT JOIN ` + appSettings.assets_db + `.assets a ON aas.asset_id = a.asset_id LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant WHERE DATE(aas.asset_service_date) <= DATE(NOW()) GROUP BY a.plant`
        const data = await manager.query(query)
        if (data) {
            return new CommonResponse(true, 1000, 'Data retrived sucessfully', data)
        } else {
            return new CommonResponse(false, 1000, 'no data found')

        }
    }

    async updateServiceRemarks(req: UpdateRemarksDto): Promise<CommonResponse> {
        const updateRemarks = await this.assetServiceRepo.update({ assetServeId: req.assetServiceId }, { remarks: req.remarks })
        const manager = getManager()
        const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.model,asr.asset_service_date as serviceDate,asr.phone_number as phoneNumber,asr.service_owner as serviceOwner,i.item_name as itemName,a.assets_code as assetCode,asr.service_owner as serviceOwner,asr.remarks,asr.asset_serve_id as serviceId,asr.status from ${appSettings.assets_db}.asset_service asr
        left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        left join ${appSettings.masters_db}.items i  on i.item_id = a.assets_name
        where asr.asset_serve_id = ${req.assetServiceId}`
        const data = await manager.query(todaysServices)
        const msgText = `*${data[0].serviceOwner}*,\\n Service note is updated against the service -  ${data[0].serviceName}   for the asset *${data[0].itemName} - ${data[0].assetCode}* \\n Service status : *${data[0].status}* \\n Service note : ${data[0].remarks}`
        const waParameters = [{ type: 'text', text: msgText }]
        const msgParameters = new MessageParameters(('91' + data[0].phoneNumber), 'service_notify', waParameters, 'en_us', data[0].serviceId)
        const sendMessage = await this.wpService.sendMessageWithButtonParamsThroughFbApi(msgParameters)
        if (updateRemarks.affected) {
            return new CommonResponse(true, 1111, 'Remarks updated')
        } else {
            return new CommonResponse(false, 2321, "Failed to update")
        }
    }
    async getInsuranceAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
        SELECT aas.asset_category,isc.item_sub_category,aas.assets_name, it.item_name AS item_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
        aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
        aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,aas.owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
        aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
        aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,aas.plant,unc.unit_name AS plantName,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_status,aas.service_type,aas.frequency_of_service,
        locc.location_id,lo.location_id ,loc.location_name ,aas.insurance_reference_number,aas.asset_type ,aas.month,aas.day,datediff(aas.insurance_date,date(now())) as assetAge
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id >0 and insurance = 'yes' `;
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        getEntities = getEntities + ` ORDER BY it.item_name ASC`

        const assetdata = await manager.query(getEntities)

        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)



    }
    async getInsuranceDropDownAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
        SELECT aas.asset_category,isc.item_sub_category,aas.assets_name, it.item_name AS item_name,aas.assets_code
        FROM ` + appSettings.assets_db + `.assets aas 
        LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
        LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
        LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
        WHERE aas.asset_id >0 and insurance = 'yes' ORDER BY it.item_name ASC `;
        const assetdata = await manager.query(getEntities)
        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }

    async getWarrantyAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
    SELECT aas.asset_category,isc.item_sub_category,aas.assets_name, it.item_name AS item_name,aas.assets_code,aas.amc_available ,aas.date_of_purchased,
    aas.name,aas.warrenty_expired_date,aas.insurance_date,aas.insurance,aas.warrenty_available,aas.expired_date,aas.asset_cost,aas.status, 
    aas.asset_serialno,aas.model,aas.year,aas.asset_supplier,aas.asset_condition,aas.owner_of_asset,aas.transaction_date,aas.decommission_approved_by,
    aas.service_tenure,aas.insurance_provided_by,aas.asset_invoice_no,aas.item_id,aas.grn_id,aas.no_of_units,aas.units_of_measurements,aas.last_checkin,aas.last_checkout,aas.amc_reason,
    aas.department,aas.employee_id,aas.maintenance_duedate,aas.asset_id,aas.plant,unc.unit_name AS plantName,assi.employee_id,empd.employee_name,empd.department_id,dep.dept_name,aas.service_status,aas.service_type,aas.frequency_of_service,
    locc.location_id,lo.location_id ,loc.location_name ,aas.insurance_reference_number,aas.asset_type ,aas.month,aas.day,datediff(aas.warrenty_expired_date,date(now())) as assetAge
    FROM ` + appSettings.assets_db + `.assets aas 
    LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
    LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
    LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
    LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
    LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
    LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
    LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
    LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
    LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
    WHERE aas.asset_id >0 and warrenty_available = 'yes' `;
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and loc.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and loc.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }

        const assetdata = await manager.query(getEntities)

        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }
    async getWarrantyDropDownAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `
    SELECT aas.asset_category,isc.item_sub_category,aas.assets_name, it.item_name AS item_name,aas.assets_code
    FROM ` + appSettings.assets_db + `.assets aas 
    LEFT JOIN `+ appSettings.masters_db + ` .unitcodes unc ON unc.unit_code_id = aas.plant
    LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lo ON lo.asset_id = aas.asset_id 
    LEFT JOIN `+ appSettings.assets_db + `.location loc ON loc.location_id = lo.location_id 
    LEFT JOIN `+ appSettings.assets_db + `.location locc ON locc.location_id = aas.asset_id 
    LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
    LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
    LEFT JOIN `+ appSettings.assets_db + `.asset_assignment assi ON assi.asset_id = aas.asset_id
    LEFT JOIN `+ appSettings.masters_db + `.employee_details empd ON empd.employee_id = assi.employee_id
    LEFT JOIN `+ appSettings.masters_db + `.departments dep ON dep.dept_id = empd.department_id
    WHERE aas.asset_id >0 and warrenty_available = 'yes'`;
        getEntities = getEntities + ` ORDER BY it.item_name ASC`
        const assetdata = await manager.query(getEntities)
        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }

    async sendServiceRemainder(): Promise<any> {
        const manager = getManager()
        const todaysServices = `select asr.service_name as serviceName,asr.asset_service_date as serviceDate,a.employee_id as employeeId,ed.employee_name as employeeName,a.model,asr.asset_service_date as serviceDate from ${appSettings.assets_db}.asset_service asr
    left join ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
    left join ${appSettings.masters_db}.employee_details ed on ed.employee_id = a.employee_id
    where DATE(asr.asset_service_date) = Date(now())`
        const data = await manager.query(todaysServices)
        const waParameters = [{ type: 'text', text: 'A Naveen ' }, { type: 'text', text: ('service :' + data[0].serviceName) }, { type: 'text', text: data[0].model.trim() }, { type: 'text', text: moment(data[0].serviceDate).format("DD-MM-YYYY") }]
        const msgParameters = new MessageParameters('917036045967', 'service_update', waParameters, 'en_gb')
        const sendMessage = await this.wpService.sendMessageWithButtonThroughFbApi(msgParameters)
        return sendMessage

    }

    async getServiceDataForServiceId(req?: UpdateServiceRemarksDto): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.service_owner as serviceOwner,a.model,asr.phone_number as phoneNumber FROM ` + appSettings.assets_db + `.asset_service asr
    LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
    LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
    LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
    LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
    LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
    LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
    WHERE a.assets_name> 0 and  asr.asset_serve_id = ${req.assetServiceId}`

        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retried Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async topResponsible(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            const qry = `SELECT COUNT(aas.asset_id) AS numberOfAssets , em.employee_name AS responsible,u.unit_name AS unit ,d.dept_name AS department FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = aas.employee_id LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id = aas.owner_of_asset LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = aas.plant LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = em.department_id WHERE em.employee_name IS NOT NULL GROUP BY em.employee_name ORDER BY COUNT(aas.asset_id) DESC LIMIT 5`
            const dropData = await manager.query(qry)
            data.push(dropData)

            if (dropData) {

                return new CommonResponse(true, 1, ' Data retrievd successfully', data)
            } else {
                return new CommonResponse(false, 99898, 'Something went wrong')
            }
        } catch (error) {
            return error
        }
    }

    async getInstockAssets(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_id,aas.assets_name,aas.asset_category,it.item_name,aas.status,aas.assets_code,it.item_id,aas.plant
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        WHERE aas.status = 'INSTOCK'`
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + 'and aas.plant = "' + req.plantId + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and aas.asset_category = "' + req.assetCategory + '"'
        }
        const assetdata = await manager.query(getEntities)
        if (getEntities?.length) {
            return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }

    }
    async getExpRents(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager();
            let month = `SELECT a.assets_code ,it.item_name AS assetName,u.unit_name AS unit, a.date_of_purchased,a.asset_rent_tenure_type , a.asset_rent_period, 
        DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period MONTH),'%Y-%m-%d') AS rentDate ,
        DATEDIFF(DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period MONTH),'%Y-%m-%d'),DATE(NOW())) AS aging
        FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = a.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant
        WHERE asset_rent_tenure_type = 'Month' AND DATE_FORMAT(DATE_ADD(date_of_purchased, 
        INTERVAL a.asset_rent_period MONTH),'%Y-%m-%d') < DATE(NOW())`;
            const assetMonthdata = await manager.query(month)
            let days = `SELECT a.assets_code ,it.item_name AS assetName,u.unit_name AS unit, a.date_of_purchased,a.asset_rent_tenure_type , a.asset_rent_period, 
        DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period DAY),'%Y-%m-%d') AS rentDate ,
        DATEDIFF(DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period DAY),'%Y-%m-%d'),DATE(NOW())) AS aging
        FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = a.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant
        WHERE asset_rent_tenure_type = 'Days' AND DATE_FORMAT(DATE_ADD(date_of_purchased, 
        INTERVAL a.asset_rent_period DAY),'%Y-%m-%d') < DATE(NOW())`;
            const assetDaydata = await manager.query(days)
            let year = `SELECT a.assets_code ,it.item_name AS assetName,u.unit_name AS unit, a.date_of_purchased,a.asset_rent_tenure_type , a.asset_rent_period, 
        DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period YEAR),'%Y-%m-%d') AS rentDate ,
        DATEDIFF(DATE_FORMAT(DATE_ADD(a.date_of_purchased, INTERVAL a.asset_rent_period YEAR),'%Y-%m-%d'),DATE(NOW())) AS aging
        FROM ` + appSettings.assets_db + `.assets a
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = a.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id = a.plant
        WHERE asset_rent_tenure_type = 'Year' AND DATE_FORMAT(DATE_ADD(date_of_purchased, 
        INTERVAL a.asset_rent_period YEAR),'%Y-%m-%d') < DATE(NOW())`;
            const assetYeardata = await manager.query(year)
            //  data.push(assetMonthdata)
            //  data.push(assetDaydata)
            //  data.push(assetYeardata)
            const mergeArry = [...assetMonthdata, ...assetDaydata, ...assetYeardata]
            return new CommonResponse(true, 1, 'Data retrieved successfully', mergeArry)
        } catch (error) {
            return error
        }
    }

    async assetHistory(req: AssetByCode): Promise<CommonResponse> {
        const manager = getManager();
        const query = `SELECT asst.created_at AS transactionDate ,asst.status AS transactionType ,asst.service_name AS serviceName ,asst.maintenance_cost AS maintenanceCost ,em.employee_name AS employeeName,d.dept_name AS department ,loc.location_name AS location ,emp.employee_name AS Approved FROM ` + appSettings.assets_db + `.assets_transactions asst LEFT JOIN ` + appSettings.assets_db + `.assets aas ON aas.asset_id = asst.asset_id LEFT JOIN ` + appSettings.masters_db + `.employee_details em ON em.employee_id = asst.employee_id LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id= asst.decommission_approved_by LEFT JOIN ` + appSettings.assets_db + `.location loc ON loc.location_id = asst.location_id LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = em.department_id WHERE aas.assets_code = '${req.assetsCode}' ORDER BY asst.created_at`
        const data = await manager.query(query)
        if (query?.length) {
            return new CommonResponse(true, 1111, 'Data Retreived Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async depreciaitionReport(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_id,aas.assets_code,aas.assets_name,aas.model,aas.asset_serialno,aas.date_of_purchased,aas.asset_cost,
        it.item_name,aas.plant,aas.asset_category,aas.asset_mode,aas.asset_type,aas.expired_date,aas.status,aas.asset_condition,
        aas.asset_invoice_no,aas.owner_of_asset,isc.item_sub_category,unc.unit_name,l.location_name,aas.asset_condition,
        DATEDIFF(DATE(NOW()),aas.date_of_purchased) AS assetAge,
        TIMESTAMPDIFF(YEAR,aas.date_of_purchased,DATE(NOW())) AS yeardiff,
        TIMESTAMPDIFF(YEAR,DATE(NOW()),aas.expired_date) AS remainingLife,
        TIMESTAMPDIFF(YEAR,aas.date_of_purchased,aas.expired_date) AS lifediff,
        ass.created_at as assetSaleDate,ass.asset_sale_cost
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant      
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = aas.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        LEFT JOIN `+ appSettings.assets_db + `.assets_sale ass ON ass.asset_id = aas.asset_id
        WHERE aas.asset_id > 0 `
        if (req.assetCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and l.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + ' and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.plant && req.location) {
            getEntities = getEntities + 'and unc.unit_name = "' + req.plant + '" and l.location_name = "' + req.location + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + 'and aas.plant = ' + req.plantId
        }
        if (req.aging != undefined) {
            if (req.aging == '50') {
                getEntities = getEntities + ' having assetAge < 50 '
            }
            if (req.aging == '51-300') {
                getEntities = getEntities + ' having assetAge between 51 and 300'
            }
            if (req.aging == '301-900') {
                getEntities = getEntities + ' having assetAge between 301 and 900'
            }
            if (req.aging == '901-1500') {
                getEntities = getEntities + ' having assetAge between 901 and 1500'
            }
            if (req.aging == '1501-2125') {
                getEntities = getEntities + ' having assetAge between 1096 and 2125'
            }
            if (req.aging == '2125-3000') {
                getEntities = getEntities + '  having assetAge between 2125 and 3000'
            }
            if (req.aging == '3000-3600') {
                getEntities = getEntities + '  having assetAge between 3000 and 3600'
            }
            if (req.aging == '3600-4200') {
                getEntities = getEntities + '  having assetAge between 3600 and 4200'
            }
            if (req.aging == 'above 4200') {
                getEntities = getEntities + ' having assetAge > 4200'
            }
        }
        if (req.aging != undefined) {
            getEntities = getEntities + ' ORDER BY assetAge ASC'
        } else {
            getEntities = getEntities + ' ORDER BY it.item_name ASC'
        }


        const data = await manager.query(getEntities)
        if (getEntities?.length) {
            return new CommonResponse(true, 1111, 'Data Retreived Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getRentedAssetsDetails(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let rentedDetailQuery = `SELECT COUNT(asset_id) AS assets,SUM(SUBSTRING_INDEX(asset_cost,'.',1)) AS cost ,aas.status FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = aas.assets_name WHERE aas.asset_mode = 'RentedAsset' GROUP BY STATUS`
            const data = await manager.query(rentedDetailQuery)
            if (rentedDetailQuery) {
                return new CommonResponse(true, 2222, 'Data Retreived Successfully', data)
            } else {
                throw new ErrorResponse(222, 'No Data Found')
            }
        } catch (error) {
            error
        }
    }
    async getAssignedforRentCatogry(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT a.asset_category,isc.item_sub_category FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON a.asset_category=isc.item_sub_category_id WHERE asset_mode = 'rentedAsset' and status = '${AssetStatusEnum.INSTOCK}' `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.asset_category ORDER BY isc.item_sub_category ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }

    }
    async getpurchasedAssetCatogry(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT a.asset_category,isc.item_sub_category FROM ' + appSettings.assets_db + `.assets a LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON a.asset_category=isc.item_sub_category_id WHERE STATUS IN ("INSTOCK") `;
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId
        }
        Query = Query + ` GROUP BY a.assets_code ORDER BY i.item_name ASC`
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }
    }
    async getTop5SaleAssets(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = 'SELECT a.asset_id,a.assets_code,it.item_name AS assetName,asset_sale_cost,u.unit_name AS unit,ass.created_at AS saleDate FROM `brandix_dev_assets`.`assets_sale` ass LEFT JOIN `brandix_dev_assets`.`assets` a ON a.asset_id = ass.asset_sale_id  LEFT JOIN `brandix_dev_masters`.unitcodes u ON u.unit_code_id = a.plant LEFT JOIN `brandix_dev_masters`.items it ON it.item_id = a.assets_name ORDER BY asset_sale_cost*1 DESC LIMIT 5';
        if (req.plantId > 0 && req.plantId != 5) {
            Query = Query + 'and a.plant = ' + req.plantId + ''
        }
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }

    async getMonthwiseAssetsSale(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let Query = '   SELECT COUNT(*) AS totalCount,SUM(asset_sale_cost) AS totalCost,MONTHNAME(created_at) AS MONTH FROM  `brandix_dev_assets`.`assets_sale` GROUP BY MONTH(created_at)';
        const result = await manager.query(Query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }
    async getAuditReportData(req?: AssetServiceRportReq): Promise<CommonResponse> {
        const manager = getManager();
        let query = 'SELECT l.location_name AS locationName,isc.item_sub_category AS categoryName,audit_type AS auditType,alm.asset_id AS assetId,DATE(audit_date) AS auditDate,a.assets_code AS assetsCode,audit_provider AS auditProvider,audit_name AS auditName,audit_owner AS auditOwner,assets_count AS assetsCount,working AS workingAssets,not_working AS notWorkingAssets,la.status,l.plant AS plant,u.unit_name AS unitName FROM `brandix_dev_assets`.`location_audit` la LEFT JOIN `brandix_dev_assets`.`location` l ON la.location_id = l.location_id LEFT JOIN `brandix_dev_masters`.`unitcodes` u ON l.plant = u.unit_code_id LEFT JOIN `brandix_dev_assets`.`asset_location_mapping` alm ON alm.location_id = l.location_id LEFT JOIN `brandix_dev_assets`.`assets` a ON a.asset_id = alm.asset_id LEFT JOIN brandix_dev_masters.item_sub_categories isc ON isc.item_sub_category_id=a.asset_category  WHERE a.asset_id >0';
        if (req.assetCode) {
            query = query + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.plant != 5) {
            query = query + ' and l.plant = ' + req.plant + ''
        }
        if (req.location) {
            query = query + ' and l.location_id =' + req.location + ''
        }
        if (req.assetCategory) {
            query = query + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.assetCategory && req.assetCode && req.location && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and l.plant = ' + req.plant + ' and l.location_id =' + req.location + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode) {
            query = query + ' and l.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.assetCategory && req.assetCode && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and l.plant = ' + req.plant + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode && req.location) {
            query = query + ' and l.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '" and l.location_id =' + req.location + ''
        }
        if (req.plant && req.location) {
            query = query + ' and l.plant = ' + req.plant + ' and l.location_id = "' + req.location + '"'
        }
        const result = await manager.query(query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }

    async getAssetSaleReport(req?: AssetServiceRportReq): Promise<CommonResponse> {
        const manager = getManager();
        let query = 'SELECT a.asset_id,a.assets_code AS assetCode,it.item_name AS assetName,asset_sale_cost AS assetSaleCost,u.unit_name AS unit ,isc.item_sub_category AS assetCategory,a.plant AS plant,l.location_name AS locationName FROM `brandix_dev_assets`.`assets_sale` ass LEFT JOIN `brandix_dev_assets`.`assets` a ON a.asset_id = ass.asset_sale_id LEFT JOIN `brandix_dev_masters`.unitcodes u ON u.unit_code_id = a.plant LEFT JOIN `brandix_dev_masters`.items it ON it.item_id = a.assets_name LEFT JOIN brandix_dev_masters.unitcodes uc ON uc.unit_code_id=a.plant LEFT JOIN brandix_dev_masters.item_sub_categories isc ON isc.item_sub_category_id=a.asset_category LEFT  JOIN brandix_dev_assets.asset_location_mapping al ON a.asset_id=al.asset_id LEFT JOIN brandix_dev_assets.location l ON l.location_id = al.location_id WHERE a.asset_id >0';
        if (req.assetCode) {
            query = query + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.plant != 5) {
            query = query + ' and a.plant = ' + req.plant + ''
        }
        if (req.location) {
            query = query + ' and l.location_id =' + req.location + ''
        }
        if (req.assetCategory) {
            query = query + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.assetCategory && req.assetCode && req.location && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and a.plant = ' + req.plant + ' and l.location_id =' + req.location + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.assetCode && req.location) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '" and l.location_id =' + req.location + 'ORDER BY asset_sale_cost*1 DESC'
        }
        const result = await manager.query(query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }
    async getVmsReportData(req?: AssetServiceRportReq): Promise<CommonResponse> {
        const manager = getManager();
        let query = '  SELECT a.asset_id,assets_name,a.assets_code AS assetCode,isc.item_sub_category AS assetCategory,l.location_name AS locationName,asset_serialno,assets_code,STATUS,HOST,host_type AS hostType,host_address AS hostAddress,provisioned_space AS provisionedSpace,used_space AS usedSpace,compatibility,memory_size AS memorySize,CPU,nic,vm_ware_version_tool_status AS vmWareVersionTool,a.plant,uc.unit_name AS plantName FROM `brandix_dev_assets`.`assets` a LEFT JOIN brandix_dev_masters.item_sub_categories isc ON isc.item_sub_category_id=a.asset_category LEFT JOIN `brandix_dev_assets`.`asset_location_mapping` alm ON  a.asset_id =alm.asset_id LEFT JOIN `brandix_dev_assets`.`location` l ON l.location_id = alm.location_id LEFT JOIN brandix_dev_masters.unitcodes uc ON uc.unit_code_id=a.plant WHERE host_type = "VM" ';
        if (req.assetCode) {
            query = query + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.plant != 5) {
            query = query + ' and a.plant = ' + req.plant + ''
        }
        if (req.location) {
            query = query + ' and l.location_id =' + req.location + ''
        }
        if (req.assetCategory) {
            query = query + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.assetCategory && req.assetCode && req.location && req.plant) {
            query = query + ' and a.assets_code = "' + req.assetCode + '" and a.plant = ' + req.plant + ' and l.location_id =' + req.location + ' and a.asset_category=' + req.assetCategory + ''
        }
        if (req.plant && req.assetCode) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.plant && req.assetCode && req.location) {
            query = query + ' and a.plant = ' + req.plant + ' and a.assets_code = "' + req.assetCode + '" and l.location_id =' + req.location + ''
        }
        const result = await manager.query(query);
        if (result.length > 0) {
            return new CommonResponse(true, 11608, 'Data Retrived Sucessfullyy.....', result)
        }
        else {
            return new CommonResponse(false, 11608, 'No data Found', result)
        }


    }

    @Cron('0 18 * * *')
    async getServiceReport() {
        try {
            const manager = getManager()
            let createdService = `SELECT COUNT(asset_serve_id) AS services FROM ` + appSettings.assets_db + `.asset_service WHERE DATE(asset_service_date) = DATE(NOW())`;
            let skipService = `SELECT COUNT(asset_serve_id) AS skip FROM ` + appSettings.assets_db + `.asset_service WHERE STATUS='OPEN' AND DATE(asset_service_date) = DATE(NOW())`;
            let inprogressService = `SELECT COUNT(asset_serve_id) AS inprogress FROM ` + appSettings.assets_db + `.asset_service WHERE STATUS='INPROGRESS' AND  DATE(asset_service_date) = DATE(NOW())`;
            let completedService = `SELECT COUNT(asset_serve_id) AS completed FROM ` + appSettings.assets_db + `.asset_service WHERE STATUS='COMPLETED' AND DATE(asset_service_date) = DATE(NOW())`;
            const created = await manager.query(createdService);
            const skip = await manager.query(skipService);
            const inprogress = await manager.query(inprogressService);
            const completed = await manager.query(completedService);
            const parameters = [
                { "type": "text", "text": moment().format('DD-MM-YYYY') },
                { "type": "text", "text": created ? created[0].services : "No Data" },
                { "type": "text", "text": skip ? skip[0].skip : "No Data" },
                { "type": "text", "text": inprogress ? inprogress[0].inprogress : "No Data" },
                { "type": "text", "text": completed ? completed[0].completed : "No Data" },

            ];
            for (const contact of whatsApp.contacts) {
                let statusFlag = true
                const req = await new MessageParameters(contact, 'asset_service_report', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                if (!messageStatus.status) {
                    statusFlag = false
                } else {
                    const whatsapplogDto = new WhatsAppLogDto(contact, 'asset_service_report', 'Brandix_assets', GlobalVariableValues.assetmanagementcompanyId, GlobalVariableValues.assetManagementmoduleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                }
            }
        } catch (err) {
            return new CommonResponse(false, 11108, "Error while sending message")
        }
    }

    async getRevenuReport(): Promise<CommonResponse> {
        const data = [];
        try {
            const manager = getManager()
            let qry = `SELECT aas.asset_category AS assetCategory ,it.item_sub_category AS category, COUNT(aas.assets_name) AS assets,SUM(aas.asset_cost) AS purchaseCost,SUM(aas.asset_cost * POWER(0.95, YEAR(CURDATE()) - YEAR(aas.date_of_purchased))) AS currentCost FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category WHERE aas.status != 'SOLD'
            GROUP BY aas.asset_category ORDER BY SUM(aas.asset_cost)*1 DESC`;
            let qry1 = `SELECT aas.asset_category AS saleCategory ,it.item_sub_category AS saleSubCategory,COUNT(sa.asset_id) AS saleAssets,SUM(sa.asset_sale_cost) AS saleCost FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category LEFT JOIN ` + appSettings.assets_db + `.assets_sale sa ON sa.asset_id = aas.asset_id GROUP BY aas.asset_category`;
            let qry2 = `SELECT aas.asset_category AS expiredCategory ,it.item_sub_category AS expiredSubCategory, COUNT(aas.assets_name) AS expiredAssets,SUM(aas.asset_cost) AS purchaseCost,SUM(aas.asset_cost * POWER(0.95, YEAR(CURDATE()) - YEAR(aas.date_of_purchased))) AS currentCost FROM ` + appSettings.assets_db + `.assets aas LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories it ON it.item_sub_category_id = aas.asset_category WHERE aas.expired_date < DATE(NOW()) GROUP BY aas.asset_category`;
            const query = await manager.query(qry);
            data.push(query)
            const query1 = await manager.query(qry1);
            data.push(query1)
            const query2 = await manager.query(qry2);
            data.push(query2)
            return new CommonResponse(true, 1, "Data Retrived Successfully", data);

        } catch (err) {
            return new CommonResponse(false, 11108, "Error while sending message")
        }

    }

    async updateServiceChecklist(req:UpdateChecklist): Promise<CommonResponse> {
        const updateChecklist = await this.checklistRepo.update({ assetServiceCheckListId: req.assetServiceChecklistId }, { condition: req.condition, reason: req.reason, checklistStatus: AssetStatusEnum.COMPLETED })
        if (updateChecklist.affected) {
            return new CommonResponse(true, 1111, 'Checklist updated')
        }else {
            return new CommonResponse(false, 2321, "Failed to update")
        }
    }

    async updateChecklist(req: UpdateChecklist[]): Promise<CommonResponse> {
        console.log(req, 'req')
        let flag = true;
        for (const id of req) {
            const updateChecklist = await this.checklistRepo.update({ assetServiceCheckListId: id.assetServiceChecklistId }, { condition: id.condition, reason: id.reason, checklistStatus: AssetStatusEnum.COMPLETED })
            console.log(updateChecklist, 'updateChecklist')
            const updateServiceStatus = await this.assetServiceRepo.update({ assetServeId: id.assetServeId }, { status: ServiceStatusEnum.COMPLETE })
            if (updateChecklist.affected == 0) {
                flag = false;
                return new CommonResponse(false, 2321, "Failed to update")
            }
        }
        if (flag) {
            return new CommonResponse(true, 1111, 'Checklist updated')
        } else {
            return new CommonResponse(false, 2321, "Failed to update")
        }
    }

    async getCurrentService(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.start_date as startDate,asr.completed_date as completedDate FROM ` + appSettings.assets_db + `.asset_service asr
        LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        WHERE asr.asset_category = ${req.assetCategory} AND asr.status = 'OPEN' AND DATE(asr.asset_service_date) = DATE(NOW())`;
        const data = await manager.query(query)
        return new CommonResponse(true, 1, "Data Retrived Successfully", data);

    }

    async getAssetChecklist(req?: AssetChecklistRequestDto): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT ac.asset_service_checklist_id, ac.checklist , ass.asset_serve_id  FROM ` + appSettings.assets_db + `.asset_service_checklist ac LEFT JOIN ` + appSettings.assets_db + `.asset_service ass ON ass.asset_serve_id = ac.asset_serve_id WHERE ass.asset_serve_id = ${req.assetServeId}`;
        const data = await manager.query(query)
        return new CommonResponse(true, 1, "Data Retrived Successfully", data);

    }

    async getLocationService(req?: AssetServiceReq): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.start_date as startDate,asr.completed_date as completedDate FROM ` + appSettings.assets_db + `.asset_service asr
        LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id 
        WHERE l.location_id = ${req.location} AND asr.status = 'OPEN' AND DATE(asr.asset_service_date) = DATE(NOW())`;
        const data = await manager.query(query)
        return new CommonResponse(true, 1, "Data Retrived Successfully", data);

    }

    async getChecklistReport(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT a.asset_id AS assetId,a.assets_name as assetName ,asr.service_name as serviceName, i.item_name AS assetName , a.assets_code AS assetCode ,ic.item_sub_category AS assetCategory , a.plant as plantId , uc.unit_name AS plant ,l.location_id as locationId , l.location_name AS locationName, i.asset_type AS assetType , a.service_tenure AS serviceTenure , a.created_at AS assetCreateDate ,asr.asset_service_date  AS serviceDate , a.status AS assetStatus , a.service_status AS serviceStatus,asr.status,asr.asset_serve_id as assetServiceId,asr.remarks,asr.service_name as serviceName,asr.service_provider as serviceProvider,asr.start_date as startDate,asr.completed_date as completedDate,acc.checklist,acc.condition,acc.reason,acc.checklist_status AS checklistStatus FROM ` + appSettings.assets_db + `.asset_service_checklist acc LEFT JOIN ` + appSettings.assets_db + `.asset_service asr ON asr.asset_serve_id = acc.asset_serve_id
        LEFT JOIN ${appSettings.assets_db}.assets a on a.asset_id = asr.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = a.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id = a.assets_name 
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = a.plant
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lm ON lm.asset_id = a.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location l ON l.location_id = lm.location_id WHERE acc.checklist_status = 'COMPLETED'`
        if (req.assetCode) {
            query = query + 'and a.assets_code = "' + req.assetCode + '"'
        }
        if (req.location) {
            query = query + 'and l.location_name = "' + req.location + '"'
        }
        if (req.assetCategory) {
            query = query + 'and ic.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.fromDate) {
            query = query + 'and asr.asset_service_date BETWEEN "' + req.fromDate + '" AND "' + req.toDate + '"'
        }
        if (req.plantId > 0 && req.plantId != 5) {
            query = query + 'and a.plant = ' + req.plantId
        } else {
            query = query + `ORDER BY asr.asset_service_date DESC `
        }

        const data = await manager.query(query)
        if (data) {
            return new CommonResponse(true, 11608, 'Data Retrieved Successfully', data)
        } else {
            return new CommonResponse(true, 11608, 'Somethig Went Wrong')
        }

    }

}
